rimg.shopify.init('[data-rimg="lazy"]', { round: 1 });

const sections = new ShopifySectionsManager();

sections.register('age-gate', section => new AgeGate.PageAgeGate(section));

const ageGatePage = document.getElementById('age-gate-page');

if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}

// Document ready
$(() => {

  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productGalleryReady = false;
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0,
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }

        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');

          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }

            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = false;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };


  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Search input hiding
  // get current input
  const currentValue = $(".search__form input[name='q']").val();
  // return amount without *
  if ($(".search__form input[name='q']").length > 0) {
    $(".search__form input[name='q']").val(currentValue.replace('*', ''));
  }

  // Collection sorting


  const sortByElements = document.querySelectorAll('[data-sort-by]');

  sortByElements.forEach(function (sortByEl) {
    sortByEl.addEventListener('change', function (e) {
      const sortValue = e.target.value;
      if (sortValue) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  });

  $('body')
    .on('change', '#tag_filter', () => {
      $('[data-option-filter] input').prop('checked', false);
      window.quickFilter.init();
    });

  $('body')
    .on('change', '#blog_filter', function () {
      const url = $(this).val();
      window.location = url;
    });

  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: ($('.content').offset()),
    }, 500);
  });

  // sp_custom scroll in to the view for facefilter
  if (window.location.href.indexOf('&sort_by') !== -1) {
    document.querySelector('.breadcrumb-collection').scrollIntoView();
  }

  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
  }

  $('body').on('mouseenter', '.icon-search', () => {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', () => {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', e => {
    const $this = $(e.currentTarget);
    $this.parent().submit();
  });

  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, { offset: '70%' });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, { offset: '70%' });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, { offset: '70%' });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, { offset: '70%' });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  window.utils.initializeTabs();
  window.accordion.init();

  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    $('body').on('click', '.collection_swatches', function (e) {
      e.preventDefault();
      $('.swatch span', $(this)).each(function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $('<img/>')[0].src = $(this).data('image');
        }
      });
    });
    $('body').on('click', '.swatch span', function (e) {
      e.preventDefault();
      const swatchImage = $(this).data('image');

      if (swatchImage && swatchImage.indexOf('no-image') === -1) {
        $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
        $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
      }
    });
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);

    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }

  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }

  // sp_custom load more changed class for from product-list -> load-more-proudcts
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.load-more-proudcts');
  }

  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('.load-more-proudcts');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function updateCartItemQuantity(cartItem) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {
      quantity: cartItem.quantity,
      line: cartItem.lineID,
    },
    success(data) {

      // if the edited line is the gift-wrap product, uncheck all toggles (your original logic)
      if (cartItem.variantID == GIFT_WRAP_ID) {
        $('input[name=add-gift-wrapping]').prop('checked', false);
      }

       // sp_custom FREE GIFT 

        // $.ajax({
        //   url: '/cart.js',
        //   dataType: 'json',
        //   cache: false,
        //   success(cart) {


        // let inCartFreeItem = false;
        // let minFreeItem = $('.cart-container form').data('free-item');

        // for (i = 0; i < cart.items.length; i++) {
        // if(cart.items[i].discounted_price == 0) {
        //   inCartFreeItem = true;
        // }
        // }

        // if (cart.total_price > minFreeItem && inCartFreeItem == false) {
        //   $.ajax({
        //     url: '/cart/add.js',
        //     dataType: 'json',
        //     cache: false,
        //     data: {
        //       quantity: 1,
        //       id: 37583887892656
        //     },
        //     success(cartItem) {
        //       $.ajax({
        //         url: '/cart.js',
        //         dataType: 'json',
        //         cache: false,
        //         success(cart) {
        //           refreshCart(cart);
        //           $('#free-gift').fancybox().trigger('click');
        //         }
        //       })
        //     }
        //   })
        // }
        //   }
        // })

      const cartItemsArray = data.items;
      const lineIDIndex = cartItem.lineID - 1;
      const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
      const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
      let initialQuantityTotal = 0;
      let apiQuantityTotal = 0;
      const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

      // (your inventory / BOGO logic unchanged)
      if ($quantityInputs.length > 1) {
        $.each($quantityInputs, (_i, input) => { initialQuantityTotal += parseInt($(input).val(), 10); });
        cartItemsArray.forEach(item => { if (item.variant_id === cartItem.variantID) apiQuantityTotal += item.quantity; });
      } else {
        initialQuantityTotal = parseInt($quantityInputs.val(), 10);
        apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
      }

      if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
        if (apiQuantityTotal === 1) {
          itemsLeftText = window.PXUTheme.translation.one_item_left;
        } else {
          itemsLeftText = window.PXUTheme.translation.items_left_text;
        }
        $('.warning--quantity').remove();

        if (totalCartItems < cartItemsArray.length) {
          if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
            cartItem.parentCartForm.submit();
          } else {
            // ↓↓↓ only change here ↓↓↓
            syncGiftWrap(data).then(cart => refreshCart(cart));
          }
        } else {
          const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
          cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .quantity`).parent().after(warning);
          cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .quantity`).val(apiLineItemQuantity);
        }
      } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
        cartItem.parentCartForm.submit();
      } else {
        // ↓↓↓ and here ↓↓↓
        syncGiftWrap(data).then(cart => refreshCart(cart));
      }
    },
    error(XMLHttpRequest) {
      let response = eval(`(${XMLHttpRequest.responseText})`);
      response = response.description;
      $('.warning').remove();

      const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
      cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .quantity`).parent().after(warning);
      cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] .quantity`).val(cartItem.quantity - 1);
    },
    complete() {
      // re-enable +/- after request completes
      cartItem.$element.find('.js-change-quantity').removeClass('is-disabled');
    }
  });
}


  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function getGiftProductFromDOM() {
  const el = document.querySelector('.cart-container[data-gift-json]');
  if (!el) return null;
    try {
      return JSON.parse(el.dataset.giftJson); // full product object
    } catch (e) {
      return null;
    }
  }

  function refreshCart(cart) {
    
    const giftProduct = getGiftProductFromDOM();
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
      $('.gift-wrap-inner').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
      $('.gift-wrap-inner').removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;

        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        cartItemsHTML += `<li class="mini-cart__item" data-line-key="${ item.key }" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-product-id="${item.product_id}"><div class="d-flex mx-5">`
          + `<a href="${item.url}">`;

        if (item.image) {
          let diffSize = '&crop=center&height=480&width=320'

          cartItemsHTML += `${'<div class="cart_image">'
            + '<img src="'}${item.image.replace('http:', '').concat('', diffSize)}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        if (item.variant_title != null) {
          let variantTitle = item.variant_title;
          cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.product_title}</a><a href="${item.url}"><span class="grey-font">${variantTitle}</span> </a>`;
        } else {
          let variantTitle = '';
          cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.product_title}</a><a href="${item.url}"><span class="grey-font">${variantTitle}</span> </a>`;
        }

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        let currentFullProduct = null;

        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `/products/${item.handle}.js`,
          success(data) {
            currentFullProduct = data;
            let productData = data;

            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price && productData.compare_at_price > productData.price) {
              productHasSale = true;
              productCompareAtPrice = productData.compare_at_price;
              if (productData.price_max && productData.variants?.[0]?.quantity_price_breaks?.length) {
                const quantityPriceBreaks = productData.variants[0].quantity_price_breaks;
                const quantity = item.quantity;

                // Find the best price break for the given quantity
                const bestBreak = quantityPriceBreaks
                  .filter(breakItem => quantity >= breakItem.minimum_quantity)
                  .sort((a, b) => b.minimum_quantity - a.minimum_quantity)[0];

                if (bestBreak) {
                  productFinalPrice = bestBreak.price;
                } else {
                  productFinalPrice = productData.variants[0].price;
                }
              } else {
                productFinalPrice = productData.price;
              }
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        // sp_custom fix default theme functionality. Show Free product label instead of price.
        // Always use item.final_price for display so automated (cart-level) discounts show correctly.
        if (item.discounted_price != 0) {
          const displayPrice = item.final_price;
          const wasPrice = productHasSale && productCompareAtPrice > displayPrice ? productCompareAtPrice : item.price;
          const hasDiscount = wasPrice > displayPrice;

          if (hasDiscount) {
            const itemPrice = `${window.Shopify.formatMoney(displayPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(wasPrice, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}`;
            saving = (wasPrice - displayPrice) * item.quantity;
            totalSaving = saving + totalSaving;
          } else {
            if (displayPrice > 0) {
              cartItemsHTML += `<span class="money">${window.Shopify.formatMoney(displayPrice, $('body').data('money-format'))}</span>`;
            } else {
              cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span>`;
            }
          }
        } else {
          cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span>`;
        }


        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        const GIFT_WRAP_VARIANT = 47221843656960;
        const hasItems = cart.items && cart.items.length > 0;
        const hasGiftWrap = hasItems && item.id === GIFT_WRAP_VARIANT;
        let hasVariantGiftWrap = false;
        let variantGiftQty = 0;

        if (item.properties && item.properties['Gift wrap']) {
          hasVariantGiftWrap = true;
          variantGiftQty = readGiftQtyFromProps(item.properties);
        }

        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div>'; 
        cartItemsHTML += '</div>'; 
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart">`;
        if (item.id !== GIFT_WRAP_VARIANT) {
          cartItemsHTML += `<span class="remove-icon"></span></a>`;
        }
        cartItemsHTML += '</div>'; // closes .d-flex
        if (item.id !== GIFT_WRAP_VARIANT) {
          cartItemsHTML += buildGiftWrapContainerHTML(
            item,
            lineID,
            cart,
            currentFullProduct,
            giftProduct,
            hasVariantGiftWrap,
            variantGiftQty,
          );
        }
        
        cartItemsHTML += '</li>';  // closes li

      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
          + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    let wrapField = cart.items.some(item => item.id === 47221843656960) ? 'showWrapField' : 'hideWrapField';

    if (cart.note) {
      cartNote = '<textarea id="note" name="note" rows="2" placeholder="Enter a special gift message here (free and optional)" class="' + wrapField + '">' + cart.note + '  </textarea>'
    } else {
      cartNote = '<textarea id="note" name="note" rows="2" placeholder="Enter a special gift message here (free and optional)" class="' + wrapField + '"></textarea>'
    }

    if ($(".free-shipping-bar").data('value')) {
      let totalCart = cart.total_price;
      let freeExpressAfter = $('.free-shipping-bar').data('value');

      if (totalCart == 0) {
        $('.popup-cart__free-shipping').addClass('d-none')
      } else {
        $('.popup-cart__free-shipping').removeClass('d-none')

        money = Math.max(freeExpressAfter - totalCart, 0);

        if ($('.b2b-checkout').length) {
          if (money > 0) {
            $('.b2b-checkout').addClass('d-none');
            $('.b2b-checkout').removeClass('d-block');
          } else {
            $('.b2b-checkout').addClass('d-block');
            $('.b2b-checkout').removeClass('d-none');
          }
        }

        $(".free-shipping-bar").find('[data-js-progress]').css({
          width: Math.min(totalCart / (freeExpressAfter / 100), 100) + '%'
        });

        if ($('.b2b-checkout').length) {
          $('.popup-cart__free-shipping')
            .find('[data-js-text]')
            .html(money > 0 ? window.PXUTheme.translation.free_shipping_html_b2b.replace('0', Shopify.formatMoney(money, $('body').data('money-format'))) : window.PXUTheme.translation.free_shipping_complete_b2b);
        } else {
          $('.popup-cart__free-shipping')
            .find('[data-js-text]')
            .html(money > 0 ? window.PXUTheme.translation.free_shipping_html.replace('0', Shopify.formatMoney(money, $('body').data('money-format'))) : window.PXUTheme.translation.free_shipping_complete);
        }
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);
    $('.cartNote').html(cartNote);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }

    if (cart.items.length > 0) {

      let optionIndex = null; // Variable to hold the index of the "Color" option

      // Assuming `cart.items[0].options_with_values` is an array of option objects
      cart.items[0].options_with_values.forEach((option, index) => {
        if (isColorOptionName(option.name)) {
          optionIndex = index;
        }
      });

      if (optionIndex != null) {
        $('.js-crosssell-popup').find('.product-crosssell').data('selected-color', toSlug(cart.items[0].options_with_values[optionIndex].value))
      }

      loadProductCrossSell(cart.items[0].product_id);
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (e) {}

    if (typeof window.spCustomUpdateUpsellDiscountLabel === 'function') {
      window.spCustomUpdateUpsellDiscountLabel(cart);
    }
  }

/* ===========================
   update cart + optionally reopen drawer sp_custom
=========================== */

  window.themeRefreshCart = function () {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

        refreshCart(cart);

        if ($('body').hasClass('fancybox-active')) {
          $.fancybox.close();
        }

        if ($('#header').is(':visible')) {
          $('#header .cart-container').addClass('active_link');
        } else if ($('.sticky_nav--stick').length) {
          $('.sticky_nav .cart-container').addClass('active_link');
        } else {
          $('.search-main-wrap .cart-container').addClass('active_link');
        }

        return cart;
    })
    .catch(err => console.error('Cart refresh failed:', err));
};


/* ===========================
   Constants + helpers
=========================== */
const GIFT_WRAP_ID = 47221843656960;
const getCart = () => $.ajax({ url: '/cart.js', dataType: 'json', cache: false });
const isWrappedLine = i => !!(i.properties && i.properties['Gift wrap']);
const changeByLine = (line, qty) => $.ajax({
  type: 'POST',
  url: '/cart/change.js',
  dataType: 'json',
  contentType: 'application/json',
  data: JSON.stringify({ line, quantity: qty })
});

/* ===========================
   sp_custom: Upsell discount labels (product page)
=========================== */
function parseUpsellLabels(raw) {
  if (!raw) return [];
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map(x => ({
        quantity: Number(x && x.quantity),
        label: ((x && x.label) != null ? String(x.label) : ''),
      }))
      .filter(x => Number.isFinite(x.quantity) && x.quantity > 0 && x.label);
  } catch {
    return [];
  }
}

function parseUpsellQtyLabels(raw) {
  if (!raw) return [];
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map(x => ({
        quantity: Number(x && x.quantity),
        discount_size: Number(x && x.discount_size) || 0,
        label: ((x && x.label) != null ? String(x.label) : ''),
      }))
      .filter(x => Number.isFinite(x.quantity) && x.quantity > 0);
  } catch {
    return [];
  }
}

function cacheUpsellLabelsForProduct(productId, raw) {
  if (!productId || !raw) return;
  const labels = parseUpsellQtyLabels(raw);
  if (!labels.length) return;
  window.cartUpsellLabelsCache = window.cartUpsellLabelsCache || {};
  window.cartUpsellLabelsCache[Number(productId)] = labels;
}

function getMaxUpsellTierQty(labels) {
  if (!labels || !labels.length) return 0;
  return labels.reduce((max, label) => Math.max(max, label.quantity), 0);
}

function shouldShowCartUpsell(labels, qtyInCart) {
  if (!labels || !labels.length) return false;
  return qtyInCart < getMaxUpsellTierQty(labels);
}

function getCartUpsellProgressMessage(labels, qtyInCart) {
  const next = pickNextUpsellLabel(labels, qtyInCart);
  if (!next) return '';

  const needed = Math.max(0, next.quantity - (Number(qtyInCart) || 0));
  const discount = next.discount_size || 0;
  const t = window.PXUTheme && window.PXUTheme.translation ? window.PXUTheme.translation : {};

  if (needed <= 1) {
    return (t.cart_upsell_unlock_one || 'Add 1 more item to unlock %%DISCOUNT%%% off')
      .replace('%%DISCOUNT%%', discount);
  }

  return (t.cart_upsell_unlock_other || 'Add %%COUNT%% more items to unlock %%DISCOUNT%%% off')
    .replace('%%COUNT%%', needed)
    .replace('%%DISCOUNT%%', discount);
}

function getCartItemVariantOptions(cartItem, fullProduct) {
  if (cartItem && Array.isArray(cartItem.variant_options) && cartItem.variant_options.length) {
    return cartItem.variant_options.slice();
  }

  if (fullProduct && fullProduct.variants && cartItem) {
    const match = fullProduct.variants.find(v => Number(v.id) === Number(cartItem.id));
    if (match && Array.isArray(match.options)) {
      return match.options.slice();
    }
  }

  if (cartItem && cartItem.variant_title && cartItem.variant_title !== 'Default Title') {
    return cartItem.variant_title.split(' / ').map(part => part.trim());
  }

  return [];
}

function getColorOptionIndexFromProduct(fullProduct) {
  if (!fullProduct || !Array.isArray(fullProduct.options)) return -1;
  return fullProduct.options.findIndex((option) => isColorOptionName(getProductOptionName(option)));
}

function findVariantMatchingColor(mergedVariants, cartVariantOptions, colorOptionIndex, colorValue) {
  if (!Array.isArray(mergedVariants) || colorOptionIndex < 0) return null;

  const targetOptions = cartVariantOptions.slice();
  targetOptions[colorOptionIndex] = colorValue;

  return mergedVariants.find((variant) => {
    if (!variant || !Array.isArray(variant.options)) return false;
    if (variant.available === false) return false;
    return variant.options.every((optionValue, index) => optionValue === targetOptions[index]);
  }) || null;
}

function normalizeSwatchHexValue(value) {
  if (typeof value === 'string') {
    const color = value.trim();
    if (/^#([0-9a-f]{3,8})$/i.test(color)) return color;
    if (/^rgba?\([^)]+\)$/i.test(color)) return color;
    return null;
  }

  if (value && typeof value === 'object') {
    if (typeof value.hex === 'string') return normalizeSwatchHexValue(value.hex);
    if (value.hex && typeof value.hex === 'object' && typeof value.hex.value === 'string') {
      return normalizeSwatchHexValue(value.hex.value);
    }
    if (typeof value.value === 'string') return normalizeSwatchHexValue(value.value);
  }

  return null;
}

function normalizeSwatchBgValue(value) {
  if (typeof value !== 'string') return null;
  const url = value.trim();
  if (!url) return null;
  if (/^https?:\/\//i.test(url) || /^\/\//.test(url) || /^\//.test(url)) return url;
  return null;
}

function normalizeVariantSwatch(variant) {
  if (!variant) return variant;
  return {
    ...variant,
    swatchHex: normalizeSwatchHexValue(variant.swatchHex),
    swatchBg: normalizeSwatchBgValue(variant.swatchBg),
  };
}

function hasUsableSwatchData(variant) {
  if (!variant) return false;
  return !!(normalizeSwatchHexValue(variant.swatchHex) || normalizeSwatchBgValue(variant.swatchBg));
}

function getCartUpsellSwatchStyle(variant) {
  if (!variant) return '';

  const safeHex = normalizeSwatchHexValue(variant.swatchHex);
  if (safeHex) {
    return ` style="background-color:${safeHex};"`;
  }

  const safeBg = normalizeSwatchBgValue(variant.swatchBg);
  if (safeBg) {
    return ` style="background-image:url('${htmlEncode(safeBg)}');background-size:cover;background-position:center;"`;
  }

  if (Array.isArray(variant.options)) {
    const colorCandidate = variant.options.find((opt) => typeof opt === 'string'
      && /^(black|white|green|blue|red|grey|gray|yellow|brown|pink|purple|natural)$/i.test(opt.trim()));
    if (colorCandidate) {
      return ` style="background-color:${htmlEncode(colorCandidate.trim().toLowerCase())};"`;
    }
  }

  return '';
}

function buildColorSwatchLookup(mergedVariants, colorOptionIndex) {
  const map = {};
  if (!Array.isArray(mergedVariants) || colorOptionIndex < 0) return map;

  mergedVariants.forEach((variant) => {
    if (!variant || !Array.isArray(variant.options)) return;

    const colorValue = variant.options[colorOptionIndex];
    if (!colorValue) return;

    const normalized = normalizeVariantSwatch(variant);
    const existing = map[colorValue];

    if (!existing || (!hasUsableSwatchData(existing) && hasUsableSwatchData(normalized))) {
      map[colorValue] = normalized;
    }
  });

  return map;
}

function buildCartUpsellSwatchesHTML(mergedVariants, cartItem, colorOptionIndex, cartVariantOptions) {
  if (!mergedVariants.length || colorOptionIndex < 0) return '';

  const colorSwatchLookup = buildColorSwatchLookup(mergedVariants, colorOptionIndex);
  const seen = new Set();
  let renderedCount = 0;
  let html = '';

  mergedVariants.forEach((variant) => {
    if (renderedCount >= 7) return;
    if (!variant || !Array.isArray(variant.options)) return;

    const colorValue = variant.options[colorOptionIndex];
    if (!colorValue || seen.has(colorValue)) return;
    seen.add(colorValue);

    const match = findVariantMatchingColor(mergedVariants, cartVariantOptions, colorOptionIndex, colorValue);
    if (!match) return;

    const swatchVariant = colorSwatchLookup[colorValue] || normalizeVariantSwatch(match);
    const slug = toSlug(colorValue);
    const swatchStyle = getCartUpsellSwatchStyle(swatchVariant);

    html += `<button type="button"
      class="cart-upsell__swatch swatch-element color ${slug}-swatch"
      data-cart-upsell-swatch
      data-variant-id="${match.id}"
      data-color-value="${htmlEncode(colorValue)}"
      aria-label="${htmlEncode(colorValue)}"
      title="${htmlEncode(colorValue)}"
      role="listitem"
      ${swatchStyle}>
      <span class="cart-upsell__swatch-ring"></span>
      <span class="cart-upsell__swatch-plus" aria-hidden="true"><span class="icon-plus"></span></span>
    </button>`;
    renderedCount += 1;
  });

  return html;
}

function buildGiftWrapInnerHTML(item, lineID, giftProduct, hasVariantGiftWrap, variantGiftQty) {
  const giftPrice = giftProduct && giftProduct.price
    ? Shopify.formatMoney(giftProduct.price, $('body').data('money-format'))
    : '';

  return `<div class="d-flex justify-content-center align-items-center">
    <input
      type="checkbox"
      id="gift-wrap-${lineID}"
      class="item-id-${lineID} mr-5 mr-10"
      name="add-gift-wrapping"
      data-label="add gift wrap"
      data-remove-item-2="mini-cart"
      data-variant-giftwrap="${item.id}"
      ${hasVariantGiftWrap ? 'checked' : ''}
    />
    <label for="gift-wrap-${lineID}" class="mb-0">
      ${window.PXUTheme.translation.add_gift_wrap}
      <span class="money">${giftPrice}</span>
    </label>
    <span class="has-tooltip ml-5" aria-describedby="gw-tip-${lineID}">
      <svg width="20" height="20" class="info-icon" tabindex="0" aria-controls="gw-tip-${lineID}" aria-haspopup="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128.55 128.55">
        <path fill="currentColor" d="M64.27,9.64c30.12,0,54.63,24.51,54.63,54.63s-24.51,54.63-54.63,54.63S9.64,94.4,9.64,64.27,34.15,9.64,64.27,9.64M64.27,3.64C30.79,3.64,3.64,30.79,3.64,64.27s27.14,60.63,60.63,60.63,60.63-27.14,60.63-60.63S97.76,3.64,64.27,3.64h0Z"/>
        <path fill="currentColor" d="M75.86,97.46c-2.85,2.51-8.56,6.54-15.43,5.7-6.21-1.01-11.07-8.39-11.07-19.29,0-2.85.34-5.7,1.01-8.89,2.52-11.57,5.2-21.3,7.38-23.65,2.18-2.52,3.86-2.69,5.71-2.52,2.01.17,4.19,1.01,4.87,2.69,1.34,2.85-2.69,14.59-4.2,23.15-1,5.54-2.51,12.75-2.51,17.62,0,2.68.5,4.86,1.68,5.37,3.35,1.68,8.89-2.01,12.24-5.87,3.19-3.52,5.37-7.38,6.54-9.9.5-1.34,1.68-1.68,2.52-1.17.67.34,1.17,1.68.5,3.36-1.51,4.03-5.54,10.07-9.23,13.42ZM65.79,41.75c-4.03-1.01-6.37-5.37-5.2-9.9,1.01-4.53,5.2-7.38,9.06-6.37,4.03.84,6.37,5.37,5.37,9.9-1.17,4.53-5.2,7.38-9.22,6.37Z"/>
      </svg>
      <span id="gw-tip-${lineID}" class="tooltip" role="tooltip">
        <span class="tooltip__label">${window.PXUTheme.translation.tooltip_giftwrap}</span>
      </span>
    </span>
    ${hasVariantGiftWrap ? `
    <div class="gift-quantity-box d-flex align-items-center">
      <span class="ss-icon gift-minus js-gift-qty-change" data-gift-func="minus">
        <span class="icon-minus"></span>
      </span>
      <input type="number" min="0" class="quantity" value="${variantGiftQty}" data-gift-qty-input />
      <span class="ss-icon gift-plus js-gift-qty-change" data-gift-func="plus">
        <span class="icon-plus"></span>
      </span>
    </div>` : ''}
  </div>`;
}

function buildCartUpsellInnerHTML(item, lineID, cart, fullProduct) {
  if (window.PXUTheme && window.PXUTheme.isB2BCustomer) return '';

  const labelsRaw = (window.cartUpsellLabelsCache && window.cartUpsellLabelsCache[item.product_id]) || [];
  const labels = parseUpsellQtyLabels(labelsRaw);
  if (!labels.length) return '';

  cacheUpsellLabelsForProduct(item.product_id, labelsRaw);

  const qtyInCart = getQtyInCartForUpsellProduct(cart, item.product_id);
  if (!shouldShowCartUpsell(labels, qtyInCart)) return '';

  const message = getCartUpsellProgressMessage(labels, qtyInCart);
  const colorOptionIndex = getColorOptionIndexFromProduct(fullProduct);
  const cartVariantOptions = getCartItemVariantOptions(item, fullProduct);
  const mergedVariants = getCartUpsellMergedVariants(fullProduct, item.product_id);
  const swatchesHTML = buildCartUpsellSwatchesHTML(mergedVariants, item, colorOptionIndex, cartVariantOptions);
  const colorOptionName = colorOptionIndex >= 0 && fullProduct && fullProduct.options
    ? getProductOptionName(fullProduct.options[colorOptionIndex])
    : '';

  return `<div class="gift-wrap-inner cart-upsell"
    data-cart-upsell
    data-product-id="${item.product_id}"
    data-line-key="${item.key}"
    data-color-option-index="${colorOptionIndex}"
    data-variant-options="${htmlEncode(JSON.stringify(cartVariantOptions))}"
    data-upsell-labels="${htmlEncode(JSON.stringify(labelsRaw))}">
    <div class="cart-upsell__inner">
      <p class="cart-upsell__message" data-cart-upsell-message>${message}</p>
      ${colorOptionIndex >= 0 && swatchesHTML ? `<div class="cart-upsell__swatches" role="list" aria-label="${htmlEncode(colorOptionName)}">${swatchesHTML}</div>` : ''}
    </div>
  </div>`;
}

function buildGiftWrapContainerHTML(item, lineID, cart, fullProduct, giftProduct, hasVariantGiftWrap, variantGiftQty) {
  const upsellHTML = buildCartUpsellInnerHTML(item, lineID, cart, fullProduct);
  const innerHTML = upsellHTML || buildGiftWrapInnerHTML(item, lineID, giftProduct, hasVariantGiftWrap, variantGiftQty);
  const innerClass = upsellHTML ? '' : (giftProduct ? '' : ' hidden');

  if (upsellHTML) {
    return `<div class="gift-wrap-container d-flex justify-content-center mt-10">${upsellHTML}</div>`;
  }

  return `<div class="gift-wrap-container d-flex justify-content-center mt-10">
    <div class="gift-wrap-inner${innerClass}">
      ${innerHTML}
    </div>
  </div>`;
}

function addCartUpsellVariantToCart(variantId, $btn) {
  if (!variantId) return;

  if ($btn && $btn.length) {
    $btn.addClass('is-loading');
  }

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    method: 'POST',
    data: { id: variantId, quantity: 1 },
  }).done(() => {
    $.getJSON('/cart.js', (cart) => {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      refreshCart(cart);

      if ($('#header').is(':visible')) {
        $('#header .cart-container').addClass('active_link');
      } else if ($('.sticky_nav--stick').length) {
        $('.sticky_nav .cart-container').addClass('active_link');
      } else {
        $('.search-main-wrap .cart-container, .top-bar .cart-container').addClass('active_link');
      }
    });
  }).fail((xhr) => {
    let response = {};
    try {
      response = JSON.parse(xhr.responseText);
    } catch (err) {
      response = {};
    }
    if (response.description) {
      alert(response.description);
    }
  }).always(() => {
    if ($btn && $btn.length) {
      $btn.removeClass('is-loading');
    }
  });
}

function getQtyInCartForProduct(cart, productId) {
  const pid = Number(productId);
  if (!Number.isFinite(pid)) return 0;
  const items = cart && cart.items ? cart.items : [];
  return items.reduce((sum, item) => {
    const itemPid = Number(item && item.product_id);
    const itemQty = Number(item && item.quantity) || 0;
    return sum + (itemPid === pid ? itemQty : 0);
  }, 0);
}

function getQtyInCartForUpsellProduct(cart, productId) {
  const pid = Number(productId);
  if (!Number.isFinite(pid)) return 0;

  const siblingIds = (window.cartUpsellSiblingIdsCache && window.cartUpsellSiblingIdsCache[pid]) || [pid];
  const idSet = new Set(siblingIds.map(Number));
  const items = cart && cart.items ? cart.items : [];

  return items.reduce((sum, item) => {
    const itemPid = Number(item && item.product_id);
    const itemQty = Number(item && item.quantity) || 0;
    return sum + (idSet.has(itemPid) ? itemQty : 0);
  }, 0);
}

function getProductOptionName(option) {
  if (option && typeof option === 'object' && option.name != null) {
    return String(option.name);
  }
  return String(option == null ? '' : option);
}

function parseInlineSwatchStyle(styleAttr) {
  const style = styleAttr || '';
  let swatchHex = null;
  let swatchBg = null;

  const bgImageMatch = style.match(/background-image:\s*url\((['"]?)([^'")]+)\1\)/i);
  if (bgImageMatch) {
    swatchBg = bgImageMatch[2];
  }

  const bgColorMatch = style.match(/background-color:\s*([^;]+)/i);
  if (bgColorMatch) {
    swatchHex = normalizeSwatchHexValue(bgColorMatch[1].trim());
  }

  return { swatchHex, swatchBg };
}

function extractColorSwatchMapFromSection($section) {
  const map = {};
  if (!$section || !$section.length) return map;

  $section.find('.swatch-element.color').each(function () {
    const $swatch = $(this);
    const colorValue = $swatch.attr('data-value');
    if (!colorValue || map[colorValue]) return;

    const $label = $swatch.find('label').first();
    const parsed = parseInlineSwatchStyle($label.attr('style'));
    if (parsed.swatchHex || parsed.swatchBg) {
      map[colorValue] = parsed;
    }
  });

  return map;
}

function variantsNeedSwatchData(variants) {
  if (!variants || !variants.length) return true;
  return variants.some((variant) => variant && !hasUsableSwatchData(variant));
}

function enrichVariantsWithSwatchMap(variants, colorOptionIndex, swatchMap) {
  if (!Array.isArray(variants) || colorOptionIndex < 0 || !swatchMap) return variants;

  return variants.map((variant) => {
    if (!variant || !Array.isArray(variant.options)) return normalizeVariantSwatch(variant);

    const colorValue = variant.options[colorOptionIndex];
    const swatch = colorValue && swatchMap[colorValue];
    const normalized = normalizeVariantSwatch(variant);

    if (!swatch) return normalized;

    return {
      ...normalized,
      swatchHex: normalizeSwatchHexValue(swatch.swatchHex) || normalized.swatchHex || null,
      swatchBg: normalizeSwatchBgValue(swatch.swatchBg) || normalized.swatchBg || null,
    };
  });
}

function getColorOptionIndexFromSection($section) {
  if (!$section || !$section.length) return -1;

  let colorOptionIndex = -1;
  $section.find('.swatch').each(function () {
    const optionIndex = Number($(this).attr('data-option-index'));
    if (!Number.isFinite(optionIndex)) return;
    if ($(this).find('.swatch-element.color').length) {
      colorOptionIndex = optionIndex;
    }
  });

  return colorOptionIndex;
}

function ensureCartUpsellVariantsCache(productId, fullProduct, $section) {
  const pid = Number(productId);
  if (!Number.isFinite(pid)) return;

  window.cartUpsellVariantsCache = window.cartUpsellVariantsCache || {};
  const cacheKey = resolveCartUpsellCacheKey(pid) || pid;
  let variants = window.cartUpsellVariantsCache[cacheKey];

  if (!variants || !variants.length) {
    if (fullProduct && Array.isArray(fullProduct.variants)) {
      variants = fullProduct.variants.map((variant) => normalizeVariantSwatch({
        id: variant.id,
        options: Array.isArray(variant.options)
          ? variant.options.slice()
          : [variant.option1, variant.option2, variant.option3].filter(Boolean),
        available: variant.available !== false,
        swatchHex: null,
        swatchBg: null,
      }));
    }
  } else {
    variants = variants.map((variant) => normalizeVariantSwatch(variant));
  }

  if (!variants || !variants.length) return;

  const $scope = ($section && $section.length) ? $section : $('.js-product-section').first();
  const swatchMap = extractColorSwatchMapFromSection($scope);
  const colorOptionIndex = fullProduct
    ? getColorOptionIndexFromProduct(fullProduct)
    : getColorOptionIndexFromSection($scope);

  if (variantsNeedSwatchData(variants) && Object.keys(swatchMap).length && colorOptionIndex >= 0) {
    variants = enrichVariantsWithSwatchMap(variants, colorOptionIndex, swatchMap);
  }

  const existing = window.cartUpsellVariantsCache[cacheKey];
  if (!existing || variants.length >= existing.length) {
    window.cartUpsellVariantsCache[cacheKey] = variants;
    window.cartUpsellVariantsCache[pid] = variants;
  }
}

function resolveCartUpsellCacheKey(productId) {
  const pid = Number(productId);
  if (!Number.isFinite(pid)) return null;

  const cache = window.cartUpsellVariantsCache || {};
  const candidateKeys = new Set([pid]);

  const siblingMap = window.cartUpsellSiblingIdsCache || {};
  Object.keys(siblingMap).forEach((ownerKey) => {
    const ids = Array.isArray(siblingMap[ownerKey]) ? siblingMap[ownerKey] : [];
    if (ids.map(Number).includes(pid)) {
      candidateKeys.add(Number(ownerKey));
      ids.forEach((id) => candidateKeys.add(Number(id)));
    }
  });

  let bestKey = pid;
  let bestScore = -1;

  candidateKeys.forEach((key) => {
    const variants = cache[key];
    if (!Array.isArray(variants) || !variants.length) return;

    const swatchCount = variants.filter((variant) => hasUsableSwatchData(variant)).length;
    const score = (variants.length * 1000) + swatchCount;
    if (score > bestScore) {
      bestScore = score;
      bestKey = key;
    }
  });

  return cache[bestKey] ? bestKey : pid;
}

function getCartUpsellMergedVariants(fullProduct, productId) {
  ensureCartUpsellVariantsCache(productId, fullProduct);

  const cacheKey = resolveCartUpsellCacheKey(productId);
  const cached = window.cartUpsellVariantsCache && window.cartUpsellVariantsCache[cacheKey];
  if (cached && cached.length) {
    return cached.map((variant) => normalizeVariantSwatch(variant));
  }

  if (!fullProduct || !Array.isArray(fullProduct.variants)) return [];

  return fullProduct.variants.map((variant) => normalizeVariantSwatch({
    id: variant.id,
    options: Array.isArray(variant.options)
      ? variant.options.slice()
      : [variant.option1, variant.option2, variant.option3].filter(Boolean),
    available: variant.available !== false,
    swatchHex: null,
    swatchBg: null,
  }));
}

function pickLastAchievedUpsellLabel(labels, qtyInCart) {
  const qty = Number(qtyInCart) || 0;
  let best = null;
  for (const l of labels) {
    // Show the biggest threshold we already reached.
    if (qty >= l.quantity && (!best || l.quantity > best.quantity)) best = l;
  }
  return best;
}

function pickNextUpsellLabel(labels, qtyInCart) {
  const qty = Number(qtyInCart) || 0;
  let next = null;
  for (const l of labels) {
    // Promote the next tier (e.g., qty=2 -> show 3-qty label)
    if (qty < l.quantity && (!next || l.quantity < next.quantity)) next = l;
  }
  return next;
}

function pickLabelToShow(labels, qtyInCart) {
  if (!labels || !labels.length) return null;

  // Default behavior: show "next tier" label. If already at/above max, keep showing max label.
  const next = pickNextUpsellLabel(labels, qtyInCart);
  if (next) return next;

  return pickLastAchievedUpsellLabel(labels, qtyInCart);
}

function ensureUpsellNextEl(container) {
  let el = container.querySelector('.upsell-next');
  if (el) return el;
  el = document.createElement('div');
  el.className = 'upsell-next w-100 is-justify-center';
  container.appendChild(el);
  return el;
}

window.spCustomUpdateUpsellDiscountLabel = function (cart) {
  if (window.PXUTheme && window.PXUTheme.isB2BCustomer) return;

  const containers = document.querySelectorAll('.upsell-discount-label[data-upsell-product-id]');
  if (!containers.length) return;

  containers.forEach(container => {
    const productId = container.getAttribute('data-upsell-product-id');
    const labels = parseUpsellLabels(container.getAttribute('data-upsell-discount-labels')) || parseUpsellLabels(window.discountLabels);
    if (!labels.length) return;

    const qty = getQtyInCartForProduct(cart, productId);
    const labelToShow = pickLabelToShow(labels, qty);

    const nextEl = ensureUpsellNextEl(container);
    if (labelToShow && labelToShow.label) {
      nextEl.innerHTML = labelToShow.label;
      nextEl.classList.remove('d-none');
    } else {
      nextEl.innerHTML = '';
      nextEl.classList.add('d-none');
    }
  });
};

function closeUpsellQtyDropdown($root) {
  $root.removeClass('is-open');
  $root.find('[data-upsell-qty-toggle]').attr('aria-expanded', 'false');
}

function openUpsellQtyDropdown($root) {
  $('[data-upsell-qty-dropdown].is-open').not($root).each(function () {
    closeUpsellQtyDropdown($(this));
  });
  $root.addClass('is-open');
  $root.find('[data-upsell-qty-toggle]').attr('aria-expanded', 'true');
}

function selectUpsellQtyOption($option) {
  const $root = $option.closest('[data-upsell-qty-dropdown]');
  const $menu = $root.find('[data-upsell-qty-menu]');
  const $hiddenInput = $root.find('[data-upsell-qty-value]');
  const $labelEl = $root.find('.upsell-qty-dropdown__button-label');
  const $priceEl = $root.find('.upsell-qty-dropdown__button-price');
  const $selectedOptionEl = $root.closest('.purchase-details__quantity').find('.selected-option');
  const label = $option.attr('data-label') || 'Single';
  const price = $option.attr('data-price') || '';

  $menu.find('.upsell-qty-option').removeClass('is-selected').attr('aria-selected', 'false');
  $option.addClass('is-selected').attr('aria-selected', 'true');

  $hiddenInput.val($option.attr('data-qty') || '1');
  $labelEl.text(label);
  $priceEl.text(price);
  if ($selectedOptionEl.length) {
    $selectedOptionEl.text(label);
  }
}

$('body').on('click', '[data-upsell-qty-toggle]', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $root = $(this).closest('[data-upsell-qty-dropdown]');
  if ($root.hasClass('is-open')) {
    closeUpsellQtyDropdown($root);
  } else {
    openUpsellQtyDropdown($root);
  }
});

$('body').on('click', '[data-upsell-qty-menu] .upsell-qty-option', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $option = $(this);
  selectUpsellQtyOption($option);
  closeUpsellQtyDropdown($option.closest('[data-upsell-qty-dropdown]'));
});

$('body').on('click', function (e) {
  if (!$(e.target).closest('[data-upsell-qty-dropdown]').length) {
    $('[data-upsell-qty-dropdown].is-open').each(function () {
      closeUpsellQtyDropdown($(this));
    });
  }
});

$(document).on('keydown', function (e) {
  if (e.key === 'Escape') {
    $('[data-upsell-qty-dropdown].is-open').each(function () {
      closeUpsellQtyDropdown($(this));
    });
  }
});

/* --- Use form-encoded payload; pass either `line` (1-based) OR `id` (line item key) --- */
function changeItem({ line = null, key = null, quantity, properties = null }) {
  const payload = { quantity };

  if (line != null)      payload.line = line;     // number (1-based)
  else if (key)          payload.id   = key;      // string: line item key "vid:hash"

  if (properties && typeof properties === 'object') {
    // Shopify needs a flat object of strings/nulls
    payload.properties = properties;
  }

  return $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    // form-encoded is most compatible
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: $.param(payload),
  });
}

/* Add stays JSON */
const addItems = (items) => $.ajax({
  type: 'POST',
  url: '/cart/add.js',
  dataType: 'json',
  contentType: 'application/json',
  data: JSON.stringify({ items }),
});

/* Read desired gift qty from properties safely */
function readGiftQtyFromProps(props) {
  if (!props) return 0;
  const raw = props._giftwrap_qty ?? props['Gift wrap qty'] ?? (props['Gift wrap'] && Number(props['Gift wrap']));
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/* Sum of all desired gift qty across lines (excludes the gift-wrap product itself) */
function sumDesiredGiftQty(cart) {
  return cart.items
    .filter(i => i.id !== GIFT_WRAP_ID)
    .reduce((sum, i) => sum + readGiftQtyFromProps(i.properties), 0);
}

/* Keep gift-wrap product quantity == sum of desired qty on lines */
function syncGiftWrap(cart) {
  const desiredTotal = sumDesiredGiftQty(cart);
  const wrapLine     = cart.items.find(i => i.id === GIFT_WRAP_ID);

  if (!wrapLine && desiredTotal > 0) {
    return addItems([{ id: GIFT_WRAP_ID, quantity: desiredTotal }]).then(getCart);
  }
  if (wrapLine && wrapLine.quantity !== desiredTotal) {
    const wrapIndex = cart.items.indexOf(wrapLine) + 1;
    return changeItem({ line: wrapIndex, quantity: desiredTotal }).then(getCart);
  }
  return $.Deferred().resolve(cart).promise();
}

/* Update ONLY properties for a specific line (by line item key), keep quantity as-is */
function setGiftWrapQtyForLine(lineKey, desiredQty) {
  return getCart().then(cart => {
    const line = cart.items.find(i => i.key === lineKey);
    if (!line) { console.error('setGiftWrapQtyForLine: line not found', { lineKey }); return cart; }

    // Clamp to line quantity
    const clamped = Math.max(0, Math.min(parseInt(desiredQty, 10) || 0, line.quantity));

    // Build properties: strings for values, null to clear
    let props;
    if (clamped > 0) {
      props = {
        ...(line.properties || {}),
        'Gift wrap'     : 'Yes',
        '_giftwrap_qty' : String(clamped),      // must be string
        // Optionally expose a human key as well:
        // 'Gift wrap qty' : String(clamped),
      };
    } else {
      // Clear gift props explicitly
      props = {
        ...(line.properties || {}),
        'Gift wrap'      : null,
        '_giftwrap_qty'  : null,
        'Gift wrap qty'  : null,
      };
    }

    // Send change with the SAME quantity, new properties, using line item key
    return changeItem({ key: line.key, quantity: line.quantity, properties: props })
      .then(getCart)
      .then(syncGiftWrap)
      .then(updated => {
        refreshCart(updated);
        return updated;
      });
  }).fail(err => {
    console.error('setGiftWrapQtyForLine error:', err?.responseText || err);
  });
}

/* ===========================
   Wire up UI (unchanged in spirit)
=========================== */

// Variant qty change (your existing handler can remain as-is)
$('body').on('change', '[data-cart-quantity-input]', function () {
  const $row = $(this).closest('[data-cart-item]');
  const cartItem = {
    lineID: Number($row.data('line-id')),
    variantID: Number($row.data('variant-id')),
    quantity: Math.max(0, parseInt($(this).val(), 10) || 0),
    parentCartForm: $(this).closest('[data-cart-form]'),
    totalDiscount: $(this).closest('[data-cart-form]').data('total-discount'),
    $element: $row
  };
  $row.find('.js-change-quantity').addClass('is-disabled');
  updateCartItemQuantity(cartItem);
});

/* ===========================
   2) Remove line handler
=========================== */
$('body').on('click', '[data-remove-item]', function (e) {
  e.preventDefault();

  const $row   = $(this).closest('[data-cart-item]');
  const lineId = Number($row.data('line-id')); // 1-based

  getCart().then(cart => {
    const idx  = lineId - 1;
    const line = cart.items[idx];
    if (!line) { console.error('Remove: line not found by index', { lineId, len: cart.items.length }); return; }

    const removedQty = line.quantity;
    const wasWrapped = isWrappedLine(line);

    return changeByLine(lineId, 0)
      .then(() => getCart())
      .then(afterRemove => {
        if (!wasWrapped) return afterRemove;

        const wrapLine = afterRemove.items.find(i => i.id === GIFT_WRAP_ID);
        if (!wrapLine) return afterRemove;

        const newQty   = Math.max(0, wrapLine.quantity - removedQty);
        if (newQty === wrapLine.quantity) return afterRemove;

        const wrapIndex = afterRemove.items.indexOf(wrapLine) + 1; // 1-based
        return changeByLine(wrapIndex, newQty).then(() => getCart());
      })
      .then(updated => refreshCart(updated));
  }).fail(err => {
    console.error('Remove item error:', err?.responseText || err);
  });
});

// Checkbox toggle – set desired gift qty to full line qty when checked, or 0 when unchecked
$('body').on('change', '[data-remove-item-2]', function (e) {
  e.preventDefault();
  const $row    = $(this).closest('[data-cart-item]');
  const lineKey = $row.attr('data-line-key');
  const checked = $(this).is(':checked');

  getCart().then(cart => {
    const line = cart.items.find(i => i.key === lineKey);
    if (!line) { console.error('toggle: line not found', { lineKey }); return; }
    const desired = checked ? line.quantity : 0;
    return setGiftWrapQtyForLine(line.key, desired);
  });
});

// +/- controls for gift qty (do NOT change variant qty; only properties)
$('body').on('click', '.js-gift-qty-change', function () {
  const $btn    = $(this);
  const $row    = $btn.closest('[data-cart-item]');
  const lineKey = $row.attr('data-line-key');
  const $input  = $row.find('[data-gift-qty-input]');
  const func    = $btn.data('gift-func');

  const current = Math.max(0, parseInt($input.val(), 10) || 0);
  let desired   = current + (func === 'plus' ? 1 : func === 'minus' ? -1 : 0);
  desired = Math.max(0, desired);

  getCart().then(cart => {
    const line = cart.items.find(i => i.key === lineKey);
    if (!line) { console.error('gift +/-: line not found', { lineKey }); return; }
    desired = Math.min(desired, line.quantity);
    $input.val(desired);
    return setGiftWrapQtyForLine(line.key, desired);
  });
});

// Manual input for gift qty
$('body').on('change', '[data-gift-qty-input]', function () {
  const $row    = $(this).closest('[data-cart-item]');
  const lineKey = $row.attr('data-line-key');
  let desired   = Math.max(0, parseInt($(this).val(), 10) || 0);

  getCart().then(cart => {
    const line = cart.items.find(i => i.key === lineKey);
    if (!line) { console.error('gift input: line not found', { lineKey }); return; }
    desired = Math.min(desired, line.quantity);
    $(this).val(desired);
    return setGiftWrapQtyForLine(line.key, desired);
  });
});









$('body').on('click', '[data-cart-upsell-swatch]:not(:disabled)', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $btn = $(this);
  const variantId = $btn.attr('data-variant-id');
  if (!variantId) return;

  addCartUpsellVariantToCart(variantId, $btn);
});

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success(itemData) {

          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          if (itemData && itemData.product_id) {
            const $productSection = $addToCartForm.closest('.js-product-section');
            const $upsellLabelsEl = $productSection.find('[data-upsell-discount-labels]').first();
            if ($upsellLabelsEl.length) {
              cacheUpsellLabelsForProduct(itemData.product_id, $upsellLabelsEl.attr('data-upsell-discount-labels'));
            } else if (window.discountLabels && window.discountLabels.length) {
              cacheUpsellLabelsForProduct(itemData.product_id, window.discountLabels);
            }
            ensureCartUpsellVariantsCache(itemData.product_id, null, $productSection);
          }

          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {

              // let inCartFreeItem = false;
              // let minFreeItem = $('.cart-container form').data('free-item');

              // for (i = 0; i < cart.items.length; i++) {
              //   // if(cart.items[i].discounted_price == 0) {
              //   //   inCartFreeItem = true;
              //   // }
              // }

              // sp_custom FREE GIFT 

              // if (cart.total_price > minFreeItem && inCartFreeItem == false) {
              //   $.ajax({
              //     url: '/cart/add.js',
              //     dataType: 'json',
              //     cache: false,
              //     data: {
              //       quantity: 1,
              //       id: 37583887892656
              //     },
              //     success(cartItem) {
              //       $.ajax({
              //         url: '/cart.js',
              //         dataType: 'json',
              //         cache: false,
              //         success(cart) {
              //           refreshCart(cart);
              //           $('#free-gift').fancybox().trigger('click');
              //         }
              //       })
              //     }
              //   })
              // }

              setTimeout(function () {

                refreshCart(cart);

                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.search-main-wrap .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  // const $cartContainer = $(this).parent();
                  // if ($cartContainer.hasClass('active_link')) {
                  //   $('body').addClass('blocked-scroll');
                  // } else {
                  //   $('body').addClass('blocked-scroll');

                  // }

                  // Scroll to the top of the page unless the header is fixed
                  // const header = document.getElementById('header');
                  // if (header.classList.contains('mobile_nav-fixed--false')) {
                  //   window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  // }
                }
              }, 500);


            },
          });
        },
        error(XMLHttpRequest) {
          let response = eval(`(${XMLHttpRequest.responseText})`);
          response = response.description;
          $('.warning').remove();

          const warning = `<p class="warning animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        },
      });

      return false;
    });
  }

  window.wishlistEngineCallback = function () {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success(cart) {
        for (i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id == 47221843656960) {
            $('input[name=add-gift-wrapping]').prop('checked', true);
          }
        }
        setTimeout(function () {

          refreshCart(cart);
          // $('.cart_items').find(`[data-variant-id="47221843656960"]`).find('.product-quantity-box').remove();

          if ($('body').hasClass('fancybox-active')) {
            $.fancybox.close();
          }

          if ($('#header').is(':visible')) {
            $('#header .cart-container').addClass('active_link');
          } else if ($('.sticky_nav--stick').length) {
            $('.sticky_nav .cart-container').addClass('active_link');
          } else {
            $('.top-bar .cart-container').addClass('active_link');
          }

          // block scrolling on mobile
          if (window.PXUTheme.media_queries.medium.matches) {
            const $cartContainer = $(this).parent();
            if ($cartContainer.hasClass('active_link')) {
              $('body').addClass('blocked-scroll');
            } else {
              $('body').addClass('blocked-scroll');
            }

            // Scroll to the top of the page unless the header is fixed
            const header = document.getElementById('header');
            if (header.classList.contains('mobile_nav-fixed--false')) {
              window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            }
          }
        }, 500);
      },
    });
  }
  window.productPage.productSwatches();

  if (window.applyInitialProductGalleryState) {
    window.applyInitialProductGalleryState();
    window.setTimeout(() => {
      window.applyInitialProductGalleryState();
    }, 400);
  }

  window.addEventListener('load', () => {
    if (window.applyInitialProductGalleryState) {
      window.applyInitialProductGalleryState();
    }
  });

  function getComplementaryVariantData($card) {
    const $json = $card.find('[data-complementary-variants]');
    if (!$json.length) return null;
    try {
      return JSON.parse($json.text());
    } catch (err) {
      return null;
    }
  }

  function normalizeComplementaryColorKey(key) {
    return String(key || '').trim().toLowerCase();
  }

  function complementaryVariantMatchesColor(variant, colorKey, colorOptionIndex, colorLabel) {
    if (colorOptionIndex == null || colorOptionIndex < 0) return true;
    if (!colorKey && !colorLabel) return true;

    const targetKey = normalizeComplementaryColorKey(colorKey);
    const targetLabel = normalizeComplementaryColorKey(colorLabel);
    const variantKey = normalizeComplementaryColorKey(variant.colorKey);

    if (targetKey && variantKey && variantKey === targetKey) return true;

    if (variant.options && variant.options[colorOptionIndex] != null) {
      const optionValue = String(variant.options[colorOptionIndex]);
      const optionKey = normalizeComplementaryColorKey(toSlug(optionValue));
      const optionLabel = normalizeComplementaryColorKey(optionValue);

      if (targetKey && (optionKey === targetKey || optionLabel === targetKey)) return true;
      if (targetLabel && (optionLabel === targetLabel || optionKey === targetLabel)) return true;
    }

    return false;
  }

  function setComplementaryProductImage($img, imageUrl) {
    if (!$img.length || !imageUrl) return;

    $img
      .attr('src', imageUrl)
      .attr('srcset', `${imageUrl} 1x`)
      .attr('data-rimg', 'loaded')
      .removeAttr('data-rimg-template data-rimg-max data-rimg-crop data-rimg-scale data-src');
  }

  function getComplementaryVariantImageUrl(data, colorKey, colorLabel) {
    const matching = data.variants.filter((v) =>
      complementaryVariantMatchesColor(v, colorKey, data.colorOptionIndex, colorLabel),
    );
    const withImage = matching.find((v) => v.image);
    if (withImage) return withImage.image;

    const targetKey = normalizeComplementaryColorKey(colorKey);
    const targetLabel = normalizeComplementaryColorKey(colorLabel);

    if (data.colorImages && data.colorImages.length) {
      if (targetKey) {
        const byKey = data.colorImages.find(
          (entry) => normalizeComplementaryColorKey(entry.colorKey) === targetKey,
        );
        if (byKey && byKey.image) return byKey.image;
      }

      if (targetLabel && data.colorOptionIndex >= 0) {
        const byLabel = data.colorImages.find((entry) => {
          const entryKey = normalizeComplementaryColorKey(entry.colorKey);
          return data.variants.some((variant) => {
            if (normalizeComplementaryColorKey(variant.colorKey) !== entryKey) return false;
            const optionValue = variant.options && variant.options[data.colorOptionIndex];
            return normalizeComplementaryColorKey(optionValue) === targetLabel;
          });
        });
        if (byLabel && byLabel.image) return byLabel.image;
      }
    }

    return data.defaultImage || null;
  }

  function pickComplementaryDisplayVariant(data, colorKey, colorLabel) {
    let variant = data.variants.find((v) => complementaryVariantMatchesColor(v, colorKey, data.colorOptionIndex, colorLabel) && v.available);
    if (!variant) {
      variant = data.variants.find((v) => complementaryVariantMatchesColor(v, colorKey, data.colorOptionIndex, colorLabel));
    }
    if (!variant) {
      variant = data.variants.find((v) => v.available) || data.variants[0];
    }
    return variant;
  }

  function pickComplementarySizeVariants(data, colorKey, colorLabel) {
    const collectBySize = (variants) => {
      const sizeMap = new Map();

      variants.forEach((variant) => {
        if (variant.size == null) return;

        const existing = sizeMap.get(variant.size);
        if (!existing) {
          sizeMap.set(variant.size, variant);
          return;
        }
        if (!existing.available && variant.available) {
          sizeMap.set(variant.size, variant);
        }
      });

      return Array.from(sizeMap.values());
    };

    const colorMatched = data.variants.filter((variant) =>
      complementaryVariantMatchesColor(variant, colorKey, data.colorOptionIndex, colorLabel),
    );
    let sizes = collectBySize(colorMatched);
    if (sizes.length) return sizes;

    const displayVariant = pickComplementaryDisplayVariant(data, colorKey, colorLabel);
    if (displayVariant && data.colorOptionIndex >= 0) {
      const fallbackKey = displayVariant.colorKey || '';
      const fallbackLabel = displayVariant.options[data.colorOptionIndex] || '';
      const displayColorMatched = data.variants.filter((variant) =>
        complementaryVariantMatchesColor(variant, fallbackKey, data.colorOptionIndex, fallbackLabel),
      );
      sizes = collectBySize(displayColorMatched);
      if (sizes.length) return sizes;
    }

    return collectBySize(data.variants);
  }

  function complementaryProductHasColorMatch(data, colorKey, colorLabel) {
    if (!colorKey && !colorLabel) return true;
    return data.variants.some((variant) =>
      complementaryVariantMatchesColor(variant, colorKey, data.colorOptionIndex, colorLabel),
    );
  }

  function updateComplementaryProductCard($card, colorKey, colorLabel) {
    const data = getComplementaryVariantData($card);
    if (!data) return;

    const displayVariant = pickComplementaryDisplayVariant(data, colorKey, colorLabel);
    const hasColorMatch = complementaryProductHasColorMatch(data, colorKey, colorLabel);
    const $img = $card.find('img.complementary-product__image-element').not('[data-rimg="noscript"]').first();
    const imageUrl = getComplementaryVariantImageUrl(data, colorKey, colorLabel);

    if (imageUrl && $img.length) {
      setComplementaryProductImage($img, imageUrl);
    }

    const $slider = $card.closest('[data-slider]');
    if ($slider.length && window.Flickity) {
      const flkty = window.Flickity.data($slider[0]);
      if (flkty) {
        window.setTimeout(() => flkty.resize(), 50);
      }
    }

    const $colorLabel = $card.find('[data-complementary-color-label]');
    if ($colorLabel.length && displayVariant && data.colorOptionIndex >= 0) {
      const variantColor = displayVariant.options[data.colorOptionIndex] || '';
      $colorLabel.text(hasColorMatch ? (variantColor || colorLabel || '') : variantColor);
    } else if ($colorLabel.length && hasColorMatch && colorLabel) {
      $colorLabel.text(colorLabel);
    }

    const $sizes = $card.find('[data-complementary-sizes]');
    if (!$sizes.length) return;

    $sizes.empty();

    pickComplementarySizeVariants(data, colorKey, colorLabel).forEach((variant) => {
      const $btn = $('<button type="button" class="complementary-product__size" data-complementary-size></button>')
        .attr('data-variant-id', variant.id)
        .text(variant.size);

      if (!variant.available) {
        $btn.prop('disabled', true).addClass('is-soldout');
      }

      $sizes.append($btn);
    });
  }

  function getActiveMainProductColor() {
    const $form = $('.js-product-section .product_form')
      .not('.product-recommendations .product_form, .product-crosssell .product_form')
      .first();

    if ($form.length && window.getActiveProductVariantFromForm) {
      const variant = window.getActiveProductVariantFromForm($form);
      const productData = $form.data('product');

      if (variant && productData) {
        let colorLabel = '';
        let colorKey = window.getVariantColorKey
          ? (window.getVariantColorKey(variant, productData.options) || '')
          : '';

        if (productData.options) {
          productData.options.forEach((optionName, index) => {
            if (isColorOptionName(optionName)) {
              colorLabel = variant.options[index] || '';
              if (!colorKey && colorLabel) {
                colorKey = toSlug(colorLabel);
              }
            }
          });
        }

        if (colorKey || colorLabel) {
          return { colorKey, colorLabel };
        }
      }
    }

    const $checkedSwatch = $('.js-product-section .swatch-element.color input:checked').closest('.swatch-element');

    if ($checkedSwatch.length) {
      return {
        colorKey: $checkedSwatch.attr('data-color-key') || toSlug($checkedSwatch.attr('data-value') || ''),
        colorLabel: $checkedSwatch.attr('data-value') || '',
      };
    }

    const $container = $('[data-complementary-products]');
    return {
      colorKey: $container.attr('data-main-color-key') || '',
      colorLabel: $container.attr('data-main-color-label') || '',
    };
  }

  function syncComplementaryProductsFromVariant(variant) {
    if (!variant) return;

    const $container = $('[data-complementary-products]');
    if (!$container.length) return;

    const $form = $('.js-product-section .product_form')
      .not('.product-recommendations .product_form, .product-crosssell .product_form')
      .first();
    if (!$form.length) return;

    const productData = $form.data('product');
    if (!productData) return;

    const variantBelongsToMainProduct = productData.variants
      && productData.variants.some((v) => String(v.id) === String(variant.id));
    if (!variantBelongsToMainProduct) return;

    let colorLabel = '';
    let colorKey = window.getVariantColorKey ? (window.getVariantColorKey(variant, productData.options) || '') : '';

    if (productData.options) {
      productData.options.forEach((optionName, index) => {
        if (isColorOptionName(optionName)) {
          colorLabel = variant.options[index] || '';
          if (!colorKey && colorLabel) {
            colorKey = toSlug(colorLabel);
          }
        }
      });
    }

    $container.removeAttr('data-complementary-synced-key');
    updateComplementaryProducts(colorKey, colorLabel);
  }

  function syncComplementaryProductsToActiveVariant() {
    const $container = $('[data-complementary-products]');
    if (!$container.length) return;

    const $form = $('.js-product-section .product_form')
      .not('.product-recommendations .product_form, .product-crosssell .product_form')
      .first();

    $container.removeAttr('data-complementary-synced-key');

    if ($form.length && window.getActiveProductVariantFromForm) {
      const variant = window.getActiveProductVariantFromForm($form);
      if (variant) {
        syncComplementaryProductsFromVariant(variant);
        return;
      }
    }

    const activeColor = getActiveMainProductColor();
    updateComplementaryProducts(activeColor.colorKey, activeColor.colorLabel);
  }

  function updateComplementaryProducts(colorKey, colorLabel) {
    const $container = $('[data-complementary-products]');
    if (!$container.length) return;

    const nextColorKey = colorKey || '';
    const nextColorLabel = colorLabel || '';

    if (
      $container.attr('data-complementary-synced-key') === nextColorKey
      && ($container.attr('data-main-color-label') || '') === nextColorLabel
    ) {
      return;
    }

    $container.attr('data-complementary-synced-key', nextColorKey);
    $container.attr('data-main-color-key', nextColorKey);
    $container.attr('data-main-color-label', nextColorLabel);

    $container.find('[data-complementary-product]').each(function () {
      updateComplementaryProductCard($(this), nextColorKey, nextColorLabel);
    });

    const sliderEl = $container.find('[data-slider]')[0];
    if (sliderEl && window.Flickity) {
      const flkty = window.Flickity.data(sliderEl);
      if (flkty) {
        window.setTimeout(() => flkty.resize(), 50);
      }
    }
  }

  function closeComplementaryPicker($card) {
    $card.find('[data-complementary-picker]').attr('hidden', true);
    $card.find('[data-complementary-atc-toggle]').removeClass('is-open').attr('aria-expanded', 'false');
    $card.find('.complementary-product__image').removeClass('is-picker-open');
  }

  function openComplementaryPicker($card) {
    $('[data-complementary-product]').not($card).each(function () {
      closeComplementaryPicker($(this));
    });

    const $container = $card.closest('[data-complementary-products]');
    updateComplementaryProductCard(
      $card,
      $container.attr('data-main-color-key') || '',
      $container.attr('data-main-color-label') || '',
    );

    $card.find('[data-complementary-picker]').removeAttr('hidden');
    $card.find('[data-complementary-atc-toggle]').addClass('is-open').attr('aria-expanded', 'true');
    $card.find('.complementary-product__image').addClass('is-picker-open');
  }

  function addComplementaryVariantToCart(variantId, $btn) {
    if (!variantId) return;

    if ($btn && $btn.length) {
      $btn.addClass('is-loading');
    }

    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      method: 'POST',
      data: { id: variantId, quantity: 1 },
    }).done(() => {
      $.getJSON('/cart.js', (cart) => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        refreshCart(cart);

        if ($('#header').is(':visible')) {
          $('#header .cart-container').addClass('active_link');
        } else if ($('.sticky_nav--stick').length) {
          $('.sticky_nav .cart-container').addClass('active_link');
        } else {
          $('.search-main-wrap .cart-container, .top-bar .cart-container').addClass('active_link');
        }
      });
    }).fail((xhr) => {
      let response = {};
      try {
        response = JSON.parse(xhr.responseText);
      } catch (err) {
        response = {};
      }
      if (response.description) {
        alert(response.description);
      }
    }).always(() => {
      if ($btn && $btn.length) {
        $btn.removeClass('is-loading');
      }
    });
  }

  $('body').on('pointerdown mousedown touchstart', '[data-complementary-atc-toggle]', function (e) {
    e.stopPropagation();
  });

  $('body').on('click', '[data-complementary-atc-toggle]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $card = $(this).closest('[data-complementary-product]');
    const hasSize = $card.attr('data-has-size-option') === 'true';

    if (!hasSize) {
      const data = getComplementaryVariantData($card);
      const colorKey = $card.closest('[data-complementary-products]').attr('data-main-color-key') || '';
      const variant = data ? pickComplementaryDisplayVariant(data, colorKey, $card.closest('[data-complementary-products]').attr('data-main-color-label') || '') : null;
      addComplementaryVariantToCart(variant ? variant.id : null, $(this));
      return;
    }

    const $picker = $card.find('[data-complementary-picker]');
    if ($picker.is('[hidden]')) {
      openComplementaryPicker($card);
    } else {
      closeComplementaryPicker($card);
    }
  });

  $('body').on('click', '[data-complementary-picker-close]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    closeComplementaryPicker($(this).closest('[data-complementary-product]'));
  });

  $('body').on('click', '[data-complementary-size]', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $btn = $(this);
    if ($btn.prop('disabled')) return;

    const $card = $btn.closest('[data-complementary-product]');
    addComplementaryVariantToCart($btn.data('variant-id'), $btn);
    closeComplementaryPicker($card);
  });

  $('body').on('click', (e) => {
    if (!$(e.target).closest('[data-complementary-product]').length) {
      $('[data-complementary-product]').each(function () {
        closeComplementaryPicker($(this));
      });
    }
  });

  $(document).on('change', '.js-product-section .product_form [data-variants]', function () {
    const $form = $(this).closest('.product_form');
    const productData = $form.data('product');
    const variantId = parseInt($(this).val(), 10);

    if (!productData || !productData.variants) return;

    const variant = productData.variants.find((v) => v.id === variantId);
    if (!variant) return;

    let colorLabel = '';
    let colorKey = '';

    if (window.getVariantColorKey) {
      colorKey = window.getVariantColorKey(variant, productData.options) || '';
    }

    if (productData.options) {
      productData.options.forEach((optionName, index) => {
        if (isColorOptionName(optionName)) {
          colorLabel = variant.options[index] || '';
          if (!colorKey && colorLabel) {
            colorKey = toSlug(colorLabel);
          }
        }
      });
    }

    $('[data-complementary-products]').removeAttr('data-complementary-synced-key');
    syncComplementaryProductsFromVariant(variant);
  });

  document.addEventListener('variantChange', (event) => {
    if (!event.detail || !event.detail.variant) return;
    syncComplementaryProductsFromVariant(event.detail.variant);

    const variant = event.detail.variant;
    const $section = $('.js-product-section')
      .not('.product-recommendations .js-product-section, .product-crosssell .js-product-section')
      .first();
    const productGallery = $section.find('.product_gallery')[0];

    if (
      productGallery
      && (
        productGallery.dataset.productColorGallery === 'true'
        || productGallery.dataset.productAlternative === 'true'
      )
      && window.syncProductGalleryToVariant
    ) {
      const $form = $section.find('.product_form').first();
      const productData = $form.data('product');
      window.syncProductGalleryToVariant(
        $section,
        variant,
        productData ? productData.options : null,
      );
    }
  });

  $('body').on('change', '.js-product-section .product_form .swatch_options input[type="radio"]', function () {
    const $form = $(this).closest('.product_form');
    if ($form.closest('.product-recommendations, .product-crosssell').length) return;

    const activeColor = getActiveMainProductColor();
    $('[data-complementary-products]').removeAttr('data-complementary-synced-key');
    updateComplementaryProducts(activeColor.colorKey, activeColor.colorLabel);
  });

  window.updateComplementaryProducts = updateComplementaryProducts;
  window.getActiveMainProductColor = getActiveMainProductColor;
  window.syncComplementaryProductsFromVariant = syncComplementaryProductsFromVariant;
  window.syncComplementaryProductsToActiveVariant = syncComplementaryProductsToActiveVariant;

  const complementaryShell = document.querySelector('[data-complementary-products]');
  if (complementaryShell) {
    const complementaryContent = complementaryShell.querySelector('[data-complementary-products-content]');
    if (complementaryContent && complementaryContent.children.length > 0) {
      syncComplementaryProductsToActiveVariant();

      if (window.initComplementaryProductsSlider) {
        window.initComplementaryProductsSlider(complementaryContent);
      }
    }
  }
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t, e) { const o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? `0${o}` : o; } if (typeof window.Shopify === 'undefined') window.Shopify = {}; window.Shopify.each = function (t, e) { for (let o = 0; o < t.length; o++)e(t[o], o); }, window.Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o; }, window.Shopify.arrayIncludes = function (t, e) { for (let o = 0; o < t.length; o++) if (t[o] == e) return !0; return !1; }, window.Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e; }, window.Shopify.isDefined = function (t) { return typeof t === 'undefined' ? !1 : !0; }, window.Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1); }, window.Shopify.extend = function (t, e) { function o() { } o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype; }, window.Shopify.locationSearch = function () { return window.location.search; }, window.Shopify.locationHash = function () { return window.location.hash; }, window.Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t); }, window.Shopify.urlParam = function (t) { const e = RegExp(`[?&]${t}=([^&#]*)`).exec(window.Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, ' ')); }, window.Shopify.newState = function (t, e) { let o; return o = window.Shopify.urlParam(t) ? window.Shopify.locationSearch().replace(RegExp(`(${t}=)[^&#]+`), `$1${e}`) : window.Shopify.locationSearch() === '' ? `?${t}=${e}` : `${window.Shopify.locationSearch()}&${t}=${e}`, o + window.Shopify.locationHash(); }, window.Shopify.setParam = function (t, e) { window.Shopify.replaceState(window.Shopify.newState(t, e)); }, window.Shopify.Product = function (t) { window.Shopify.isDefined(t) && this.update(t); }, window.Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property]; }, window.Shopify.Product.prototype.optionNames = function () { return window.Shopify.getClass(this.options) == 'Array' ? this.options : []; }, window.Shopify.Product.prototype.optionValues = function (t) { if (!window.Shopify.isDefined(this.variants)) return null; const e = window.Shopify.map(this.variants, e => { const o = `option${t + 1}`; return void 0 == e[o] ? null : e[o]; }); return e[0] == null ? null : window.Shopify.uniq(e); }, window.Shopify.Product.prototype.getVariant = function (t) { let e = null; return t.length != this.options.length ? e : (window.Shopify.each(this.variants, o => { for (var i = !0, r = 0; r < t.length; r++) { const n = `option${r + 1}`; o[n] != t[r] && (i = !1); } return i == 1 ? void (e = o) : void 0; }), e); }, window.Shopify.Product.prototype.getVariantById = function (t) { for (let e = 0; e < this.variants.length; e++) { const o = this.variants[e]; if (t == o.id) return o; } return null; }, window.Shopify.money_format = '$', window.Shopify.formatMoney = function (t, e) { function o(t, e) { return typeof t === 'undefined' ? e : t; } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ','), r = o(r, '.'), isNaN(t) || t == null) return 0; t = (t / 100).toFixed(e); const n = t.split('.'); const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`); const s = n[1] ? r + n[1] : ''; return a + s; } typeof t === 'string' && (t = t.replace('.', '')); let r = ''; const n = /\{\{\s*(\w+)\s*\}\}/; const a = e || this.money_format; switch (a.match(n)[1]) { case 'amount': r = i(t, 2); break; case 'amount_no_decimals': r = i(t, 0); break; case 'amount_with_comma_separator': r = i(t, 2, '.', ','); break; case 'amount_with_apostrophe_separator': r = i(t, 2, "'", '.'); break; case 'amount_no_decimals_with_comma_separator': r = i(t, 0, '.', ','); } return a.replace(n, r); }, window.Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = 'selector-wrapper', this.selectorClass = 'single-option-selector', this.variantIdFieldIdSuffix = '-variant-id', this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new window.Shopify.Product(e.product), this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () { }, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new window.Shopify.OptionSelectors.HistoryState(this)), !0; }, window.Shopify.OptionSelectors.prototype.initDropdown = function () { const t = { initialLoad: !0 }; const e = this.selectVariantFromDropdown(t); if (!e) { const o = this; setTimeout(() => { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t); }); } }, window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { const e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t); }, window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) { const e = document.getElementById(t); const o = e.parentNode; window.Shopify.each(this.buildSelectors(), t => { o.insertBefore(t, e); }), e.style.display = 'none', this.variantIdField = e; }, window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { let e = document.getElementById(this.domIdPrefix).querySelector('[selected]'); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; const o = e.value; return this.selectVariant(o, t); }, window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { const e = window.Shopify.urlParam('variant'); return this.selectVariant(e, t); }, window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { const o = this.product.getVariantById(t); if (o == null) return !1; for (let i = 0; i < this.selectors.length; i++) { const r = this.selectors[i].element; const n = r.getAttribute('data-option'); const a = o[n]; a != null && this.optionExistInSelect(r, a) && (r.value = a); } return typeof jQuery !== 'undefined' ? jQuery(this.selectors[0].element).trigger('change', e) : this.selectors[0].element.onchange(e), !0; }, window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (let o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0; }, window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { window.Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = `product-${this.product.id}-variant-selector`; const o = document.getElementById(t); window.Shopify.each(this.buildSelectors(), t => { o.appendChild(t); }); }, window.Shopify.OptionSelectors.prototype.buildSelectors = function () { for (let t = 0; t < this.product.optionNames().length; t++) { const e = new window.Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e); } const o = this.selectorDivClass; const i = this.product.optionNames(); const r = window.Shopify.map(this.selectors, t => { const e = document.createElement('div'); if (e.setAttribute('class', o), i.length > 1) { const r = document.createElement('label'); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r); } return e.appendChild(t.element), e; }); return r; }, window.Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { const o = this.selectors[e].element.value; t.push(o); } return t; }, window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { const o = this.selectedValues(); const i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), this.historyState != null && this.historyState.onVariantChange(i, this, e); }, window.Shopify.OptionSelectorsFromDOM = function (t, e) { const o = e.optionNames || []; const i = e.priceFieldExists || !0; const r = e.delimiter || '/'; const n = this.createProductFromSelector(t, o, i, r); e.product = n, window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e); }, window.Shopify.extend(window.Shopify.OptionSelectorsFromDOM, window.Shopify.OptionSelectors), window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!window.Shopify.isDefined(o)) var o = !0; if (!window.Shopify.isDefined(i)) var i = '/'; const r = document.getElementById(t); const n = r.childNodes; let a = (r.parentNode, e.length); const s = []; window.Shopify.each(n, (t, r) => {
    if (t.nodeType == 1 && t.tagName.toLowerCase() == 'option') {
      const n = t.innerHTML.split(new RegExp(`\\s*\\${i}\\s*`)); e.length == 0 && (a = n.length - (o ? 1 : 0)); const p = n.slice(0, a); const l = o ? n[a] : ''; const c = (t.getAttribute('value'), {
        available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2],
      }); s.push(c);
    }
  }); const p = { variants: s }; if (e.length == 0) { p.options = []; for (let l = 0; a > l; l++)p.options[l] = `option ${l + 1}`; } else p.options = e; return p;
}, window.Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement('select'); for (let r = 0; r < i.length; r++) { const n = document.createElement('option'); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n); } return this.element.setAttribute('class', this.multiSelector.selectorClass), this.element.setAttribute('data-option', `option${e + 1}`), this.element.id = `${t.domIdPrefix}-option-${e}`, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i); }, !0; }, window.Shopify.Image = {
  preload(t, e) { for (let o = 0; o < t.length; o++) { const i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)); } }, loadImage(t) { (new Image()).src = t; }, switchImage(t, e, o) { if (t && e) { const i = this.imageSize(e.src); const r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r; } }, imageSize(t) { const e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return e != null ? e[1] : null; }, getSizedImageUrl(t, e) { if (e == null) return t; if (e == 'master') return this.removeProtocol(t); const o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (o != null) { const i = t.split(o[0]); const r = o[0]; return this.removeProtocol(`${i[0]}_${e}${r}`); } return null; }, removeProtocol(t) { return t.replace(/http(s)?:/, ''); },
}, window.Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t); }, window.Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener('popstate', e => { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }); }); }, window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || window.Shopify.setParam('variant', t.id)); }, window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState; };

$(document)
  .on('shopify:block:select', e => {
    const { blockId } = e.detail;
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials') || $parentSection.hasClass('shopify-section--shoppable-image--slider-enabled')) {
      sliderBlock.select(blockId, $parentSection);
    }
  });

$(document)
  .on('shopify:block:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
  });

$(document)
  .on('shopify:section:reorder', e => {
    window.utils.initializeSectionWrapper();
  });

$(document)
  .on('shopify:section:load', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.accordion.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
    }

    if ($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template') || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      window.collectionSidebarFilter.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.sidebarAccordions.init();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.searchAutocomplete.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.meganavManager.injectAll();
      window.header.init();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.add($parentSection[0]);
    }
  });

$(document)
  .on('shopify:section:unload', e => {
    const $target = $(e.target);
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.unload($parentSection.find('[data-logo-wrapper]'));
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
      window.utils.initializeSectionWrapper();
    });
  });

$(document)
  .on('shopify:section:select', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  });

$(document)
  .on('shopify:section:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.deselect();
    }
  });

$(document).ready(function () {
  if (window.innerWidth < 798) {
    var cartAllContainer = $('.cart_content');
    hasVerticalScrollbar = cartAllContainer.height() > ($(window).height() + 20);

    if (hasVerticalScrollbar) {
      var button = $('.cart_content .add_to_cart');
      buttonClone = $('.top-bar--right-menu .action_button').clone().appendTo('.cart_content .cloned-btn-inner').addClass('clonedButton');
      buttonCloneInner = $('.cart_content .cloned-btn-inner');
      //.prepend('<div class="cloned-btn-inner">').append('</div>')

      cartAllContainer.on("scroll", function () {
        if ((cartAllContainer.scrollTop() + cartAllContainer.height()) == cartAllContainer.height()) {
          button.stop(true).animate({
            opacity: 0
          }, 0);
          buttonClone.stop(true).animate({
            opacity: 1
          }, 0);
          buttonCloneInner.stop(true).animate({
            opacity: 1
          }, 0);
        } else {
          button.stop(true).animate({
            opacity: 1
          }, 0);
          buttonClone.stop(true).animate({
            opacity: 0
          }, 0);
          buttonCloneInner.stop(true).animate({
            opacity: 0
          }, 0);
        }
      });
    }
  }

  // $(document).on("click", "#item1", function () {
  //   $('li #note-gift').hide();
  //   if ($('input[name=add-gift-wrapping]').prop('checked', true)) {
  //     $('li #note-gift').show();
  //   }

  //   if ($('.cart_items').find('.mini-cart__item-title a[href*="/products/gift-wrapping?variant=47221843656960"]').first().text().trim() == "Gift Wrapping") {
  //     $('.cart_content').find('#item1').prop('checked', true).removeClass('add_to_cart ajax-submit');
  //   } else {
  //     $('.cart_content').find('#item1')[0].checked = false;
  //   }
  // });
});

// if ($('.mini-cart__item-title a[href*="/products/gift-wrapping?variant=47221843656960"]').first().text().trim() == "Gift Wrapping") {
//   $('input[name=add-gift-wrapping]').prop('checked', true).removeClass('add_to_cart ajax-submit');
//   $('#note').show();
//   $('.cart_items').find(`[data-variant-id="47221843656960"]`).find('.product-quantity-box').remove();
// } else {
//   $('#note').hide();
//   $('input[name=add-gift-wrapping]').prop('checked', false).addClass('add_to_cart ajax-submit');
// }


// $(document).ready ( function () {
//   $(document).on ("click", "#item1", function () {
//     if($('.item_title a[href*="gift-wrapping"]').first().text().trim() == "Gift wrapping") {

//       $('#note').show();
//       $(this).removeClass('add_to_cart ajax-submit').removeAttr('checked');

//     } else {
//       $('#note').hide();
//       $(this).addClass('add_to_cart ajax-submit').prop('checked', false).removeAttr('checked');
//     }
//   });
// });




// discount pop-up
// https://menique.com/discount/testaviciusTestuojasi?redirect=%2Fcollections%2Fall?discount-banner
if (window.location.href.indexOf("discount-banner") > -1) {
  $(window).on('load', function () {
    $('#discount-banner').fancybox().trigger('click');
  });
}

// custom desktop search
$(document).ready(function () {
  $('.desktop-search-icon').click(function () {
    $(".desktop-search").toggle();
  });
});

$('.toggle').click(function () {
  $('body').find('.mobile-sidebar').toggle();
});

$('.collection-img-desc .readMore').on("click", function () {
  var text = $('.collection-img-desc .readMore').text();
  $('.collection-img-desc .readMore').text(
    text == window.PXUTheme.theme_settings.read_more ? window.PXUTheme.theme_settings.read_less : window.PXUTheme.theme_settings.read_more);
})

// custom collection page text hide
var textHolder = $('.collection-img-desc p');
var textHolderDesc = $('.collection-img-desc .description');
var btn = $('.btn');

if (textHolder) {
  btn.on('click', function () {
    textHolderDesc.toggleClass("extend");
    textHolder.toggleClass("extend");
  })
}

//product accordion
$('.accordion-item .heading').on('click', function (e) {
  // e.preventDefault();

  // Add the correct active class
  if ($(this).closest('.accordion-item').hasClass('active')) {
    // Remove active classes
    $('.accordion-item').removeClass('active');
  } else {
    // Remove active classes
    $('.accordion-item').removeClass('active');

    // Add the active class
    $(this).closest('.accordion-item').addClass('active');
  }

  // Show the content
  var $content = $(this).next();
  $content.slideToggle(300);
  if (window.screen.width > 480) {
    $('.accordion-item .content').not($content).slideUp('slow');
  }
});




$(document).ready(function () {

  function toggleMobileMenu(menuType) {
    $('.main-mobile-collections-women, .main-mobile-collections-men, .main-mobile-collections-kids, .main-mobile-collections-home').removeClass('active-nav');
    $('.mobile-dropdown-women, .mobile-dropdown-men, .mobile-dropdown-kids, .mobile-dropdown-home').removeClass('display-block');
    $('.mobile-dropdown-' + menuType).addClass('display-block');
    $('.main-mobile-collections-' + menuType).addClass('active-nav');
  }

  let selectedMenu = $('body').attr('data-menu-type');

  toggleMobileMenu(selectedMenu);

  $('.main-mobile-collections-women, .main-mobile-collections-men, .main-mobile-collections-kids, .main-mobile-collections-home').on('click', function () {
    var menuType = $(this).data('menu-type');
    $(this).toggleClass('active-nav');
    toggleMobileMenu(menuType);
  });

  // important fix don't hide about us on mobile 
  $('.mobile-dropdown-about').parent().find('.parent-link--true').removeClass('d-none');
  $('.mobile-dropdown-sale').parent().find('.parent-link--true').removeClass('d-none');

});

// $('.collection-product-slider').flickity({
//   pageDots: false,
//   wrapAround: true
// });

if (window.screen.width > 480) {
  $('.flickity-button').hover(function () {
    $(this).parent().parent().parent().parent().find('.thumbnail-overlay').toggleClass('zeroOpacity');
    $(this).parent().parent().parent().parent().find('.product_image').toggleClass('z-index-9');
    $(this).on('click', function (event) {
      event.preventDefault();
    })
  })
}

$('.flickity-button').on('click', function (event) {
  event.preventDefault();
})

// $('.product-wrap').hover( function(){
//   $(this).find('.flickity-button').each(function() {
//     $(this).toggleClass('showSwipBtn');
//   })
// })


// var options = {
//   prevNextButtons: false,
//   pageDots: false,
//   cellAlign: "left",
//   freeScroll: true,
//   contain: true,  
//   // imagesLoaded: true,
//   adaptiveHeight: true
// };

// if ( matchMedia('screen and (min-width: 1000px)').matches ) {
//   options.cellAlign = "center";
// }

//  $('.coll-swatch-wrap').flickity(options); 

// $('.coll-product-color').on('click', function(e){
//   e.preventDefault();
//   var productImgUrl= $(this).data('product-img');
//   $(this).parent().parent().parent().parent().find('img.is-selected').first().attr( 'srcset', productImgUrl)
// })

// popup wholesale code
// const modals = document.querySelectorAll('[data-modal]');

// modals.forEach(function (trigger) {
//   trigger.addEventListener('click', function (event) {

//     event.preventDefault();
//     const modal = document.getElementById(trigger.dataset.modal);
//     modal.classList.add('open');
//     const exits = modal.querySelectorAll('.modal-exit');
//     exits.forEach(function (exit) {
//       exit.addEventListener('click', function (event) {
//         event.preventDefault();
//         modal.classList.remove('open');
//       });
//     });
//   });
// });




////////////////////////////////////

// function setCookie1(name, value, days) {
//   var expires = "";
//   if (days) {
//     var date = new Date();
//     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//     expires = "; expires=" + date.toUTCString();
//   }
//   document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// function getCookie2(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(";");
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == " ") c = c.substring(1, c.length);
//     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//   }
//   return null;
// }

// function eraseCookie(name) {
//   document.cookie =
//     name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
// }

// let dataInfo = [
//   {
//     id: "US",
//     text: "United States",
//     standard: "5-15<br/> <span class=\"font-weight-nrml\">business days</span>",
//     standardCost: "$4.95",
//     standardCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over $75)</span>',
//     express: "2-4<br/> <span class=\"font-weight-nrml\">business days</span>",
//     expressCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over $150)</span>',
//     expressPrice: "$9.95",
//     linenDelivery: "2-4<br/> <span class=\"font-weight-nrml\">business days</span><br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "ALWAYS FREE"
//   },
//   {
//     id: "CA",
//     text: "Canada",
//     standard: "7-20<br/> <span class=\"font-weight-nrml\">business days</span>",
//     standardCost: "$6.95",
//     standardCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over $99)</span>',
//     express: "3-6<br/> <span class=\"font-weight-nrml\">business days</span>",
//     expressCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over $199)</span>',
//     expressPrice: "$14.95",
//     linenDelivery: "2-4<br/> <span class=\"font-weight-nrml\">business days</span><br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "ALWAYS FREE"
//   },
//   {
//     id: "AU",
//     text: "Australia",
//     standard: "7-20<br/> <span class=\"font-weight-nrml\">business days</span>",
//     standardCost: "$6.95",
//     standardCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over $99)</span>',
//     express: "3-6<br/> <span class=\"font-weight-nrml\">business days</span>",
//     expressCostOver: '$35.95</span>',
//     expressPrice: "$35.95",
//     linenDelivery: "2-4<br/> <span class=\"font-weight-nrml\">business days</span><br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "ALWAYS FREE"
//   },
//   {
//     id: "GB",
//     text: "United Kingdom",
//     standard: "5-12 <br/><span class=\"font-weight-nrml\">business days</span>",
//     standardCost: "£3.95",
//     standardCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over £40)</span>',
//     express: "2-4<br/> <span class=\"font-weight-nrml\">business days</span>",
//     expressCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over £90)</span>',
//     expressPrice: "£14.95",
//     linenDelivery: "2-4<br/> <span class=\"font-weight-nrml\">business days</span><br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "ALWAYS FREE"
//   },
//   {
//     id: "DE",
//     text: "Germany",
//     standard: "3-10<br/> Werktage",
//     standardCost: "€4.95",
//     standardCostOver: 'KOSTENLOSER VERSAND<br/> <span class="grey-font font-weight-nrml">(über €75)</span>',
//     express: "1-3<br/> Werktage",
//     expressCostOver: 'KOSTENLOSER VERSAND<br/> <span class="grey-font font-weight-nrml">(über €150)</span>',
//     expressPrice: "€14.95",
//     linenDelivery: "2-4 <br/>Werktage<br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "IMMER FREI"
//   },
//   {
//     id: "ES",
//     text: "Spain",
//     standard: "5-12<br/>días hábiles",
//     standardCost: "€4.95",
//     standardCostOver: 'ENVÍO GRATIS<br/> <span class="grey-font font-weight-nrml">(a partir de €75)</span>',
//     express: "1-2<br/> días hábiles",
//     expressCostOver: 'ENVÍO GRATIS<br/> <span class="grey-font font-weight-nrml">(a partir de €150)</span>',
//     expressPrice: "€14.95",
//     linenDelivery: "2-4<br/> días hábiles<br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "SIEMPRE LIBRE"
//   },
//   {
//     id: "MX",
//     text: "Mexico",
//     standard: "7-20 <br/>días hábiles",
//     standardCost: "$4.95",
//     standardCostOver: 'ENVÍO GRATIS<br/> <span class="grey-font font-weight-nrml">(a partir de $75)</span>',
//     express: "no service",
//     expressCostOver: 'no service',
//     expressPrice: "no service",
//     linenDelivery: "2-4 <span class=\"font-weight-nrml\">días hábiles</span><br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "SIEMPRE LIBRE"
//   },
//   {
//     id: "LT",
//     text: "Lietuva",
//     standard: "1-3 <br/>business days",
//     standardCost: "€4.95",
//     standardCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(from €75)</span>',
//     express: "no service",
//     expressCostOver: 'no service',
//     expressPrice: "no service",
//     linenDelivery: "2-4<br/> business days<br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "ALWAYS FREE"
//   },
//   {
//     id: "FR",
//     text: "France",
//     standard: "2-8<br/> jours ouvrable",
//     standardCost: "€4.95",
//     standardCostOver: 'livraison gratuite <br/> <span class="grey-font font-weight-nrml">(à partir de €75)</span>',
//     express: "1-2 <br/>jours ouvrables",
//     expressCostOver: 'livraison gratuite <br/> <span class="grey-font font-weight-nrml">(à partir de €150)</span>',
//     expressPrice: "€14.95",
//     linenDelivery: "2-4<br/> jours ouvrable<br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "TOUJOURS LIBRE"
//   },
//   {
//     id: "EU",
//     text: "Europe",
//     standard: "5-15<br/> <span class=\"font-weight-nrml\">business days</span>",
//     standardCost: "€4.95",
//     standardCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over €75)</span>',
//     express: "1-2<br/> <span class=\"font-weight-nrml\">business days</span>",
//     expressCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over €150)</span>',
//     expressPrice: "€14.95",
//     linenDelivery: "2-4<br/> <span class=\"font-weight-nrml\">business days</span><br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "ALWAYS FREE"
//   },
//   {
//     id: "REST",
//     text: "Rest of the World",
//     standard: "7-20<br/> <span class=\"font-weight-nrml\">business days</span>",
//     standardCost: "$4.95",
//     standardCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over $75)</span>',
//     express: "3-6<br/> <span class=\"font-weight-nrml\">business days</span>",
//     expressCostOver: 'FREE<br/> <span class="grey-font font-weight-nrml">(over $150)</span>',
//     expressPrice: "$19.95",
//     linenDelivery: "2-4<br/> <span class=\"font-weight-nrml\">business days</span><br/>(Made-to-order: +1-2 weeks)",
//     linenPrice: "ALWAYS FREE"
//   },
// ];

// if ($('.mySelect2')[0]) {
//   $(".mySelect2").select2({ data: dataInfo });
// }

// // var return_first;

// function callback(response) {
//   return_first = response;

//   setCookie1("countryCode", return_first.country_code, 7);
//   setCookie1("continentCode", return_first.continent_code, 7);
// }

// function getGeolocationData() {
//   $.ajax({
//     'url': "https://ipgeolocation.abstractapi.com/v1/?api_key=f0ac10ae223f4617906a12d22f5be2c2",
//     'success': function (data) {
//       callback(data);
//       $('.mySelect2').val(data.country_code).trigger('change');

//       fillTable();

//     },
//   });
// }

// function fillTable() {
//   var dataObject = $('.mySelect2').select2('data')[0];

//   if (dataObject) {

//     var countyList = ["US", "CA", "AU", "DE", "ES", "LT", "GB", "MX", "FR"];

//     if (countyList.includes(dataObject.id)) {
//       $('.free-shipping-text .fflag').removeAttr('class');
//       var flagClass = 'fflag ff-sm fflag-' + dataObject.id;
//     } else {
//       $('.free-shipping-text .fflag').removeAttr('class');
//       var flagClass = 'fflag ff-sm fflag-zz';
//     }

//     $('.free-shipping-text div').addClass(flagClass);

//     $(".standard-ship").html(dataObject.standard);
//     $(".standard-ship-cost").html(dataObject.standardCost);
//     $(".standard-cost-over").html(dataObject.standardCostOver);
//     $(".express-ship").html(dataObject.express);
//     $(".express-ship-cost").text(dataObject.expressPrice);
//     $(".express-cost-over").html(dataObject.expressCostOver);
//     $(".linen-ship").html(dataObject.linenDelivery);
//     $(".linenPrice-ship").text(dataObject.linenPrice);

//     if (dataObject.id == 'US' || dataObject.id == 'GB') {
//       $(".standardShip").hide();
//     } else {
//       $(".standardShip").show();
//     }



//     if (dataObject.id == 'REST' || dataObject.id == 'AU' || dataObject.id == 'CA') {
//       $(".standardTrackedShip").hide();
//     } else {
//       $(".standardTrackedShip").show();
//     }
//   }
// }

// if ($('.mySelect2')[0]) {
//   var dataObject = $('.mySelect2').select2('data')[0];
// }


// // eraseCookie("countryCode");
// // eraseCookie("continentCode");
// var countryCode = getCookie2("countryCode");
// var continentCode = getCookie2("continentCode");

// if ($('.mySelect2')[0]) {
//   if (continentCode === null) {
//     getGeolocationData();
//   }

//   if (countryCode) {
//     $('.mySelect2').val(countryCode).trigger('change');

//     fillTable();
//   }

//   $(".open-dropdown").click(function () {
//     $(".mySelect2").select2("open");
//   });

//   $('.mySelect2').on('select2:select', function (e) {
//     fillTable();
//   });
// }





// Get the modal element
const modal = document.getElementById("myModal");

// Get the button that opens the modal
const btnPopup = document.getElementById("openModalBtnPopup");

// Get the close button
const closeBtnPopup = document.getElementsByClassName("close")[0];

if (btnPopup) {
  // When the user clicks the button, open the modal
  btnPopup.onclick = function () {
    modal.style.display = "flex";
  };

  // When the user clicks on the close button, close the modal
  closeBtnPopup.onclick = function () {
    modal.style.display = "none";
  };

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
}

$(document).ready(function () {
  $('.bundle-swatch-wrap .swatch-element').on('click', function () {
    let bundleImgNum = $(this).data('id');
    let optIndex = $(this).parent().parent().parent().data('option-index');

    var secondAttr = $('.multi_select').find("[data-bundle-img-index='" + bundleImgNum + "']").attr('data-bundle-second-img-url');
    var thirdAttr = $('.multi_select').find("[data-bundle-img-index='" + bundleImgNum + "']").attr('data-bundle-third-img-url');

    if (typeof secondAttr !== 'undefined' && secondAttr !== false && optIndex == 1) {
      var selectedImage = $('.multi_select').find("[data-bundle-img-index='" + bundleImgNum + "']").data('bundle-second-img-url');
    } else if (typeof thirdAttr !== 'undefined' && thirdAttr !== false && optIndex == 2) {
      var selectedImage = $('.multi_select').find("[data-bundle-img-index='" + bundleImgNum + "']").data('bundle-third-img-url');
    } else {
      // var selectedImage = $('.multi_select').find("[data-bundle-img-index='" + bundleImgNum + "']").data('bundle-img-url');
      var selectedImage = $(this).find('label').data('image');
    }

    let imageElem = $(this).parent().parent().parent().find('.bundle-img img').attr('src', selectedImage);
    selectedImage = 'https:' + selectedImage;
  });

});

function openInNewTab(url) {
  window.open(url).focus();
}

function toggleTab(index) {
  var tabs = document.getElementsByClassName('tab');
  var buttons = document.getElementsByClassName('tab-button');

  if (tabs.length > 0) {
    // Hide all tabs and deactivate all buttons
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].style.display = 'none';
      buttons[i].classList.remove('active');
    }

    // Show the selected tab and activate the corresponding button
    tabs[index].style.display = 'block';
    buttons[index].classList.add('active');
  }
}

// Show the first tab by default
toggleTab(0);

$(document).ready(function () {
  $('.metric-converter').on('click', function () {
    $(this).toggleClass('metric');
    $(this).parent().parent().parent().toggleClass('metric');
    $('.metric-converter-container .bolder').toggleClass('active');
  });

  $('.size-chart-toggle').on('click', function () {
    $(this).toggleClass('active');
    $('.garment-size-btn').toggleClass('active');
    $('.body-size-btn').toggleClass('active');
    $('.body-size-chart').toggleClass('active');
    $('.garment-size-chart').toggleClass('active');
  });
});

function toggleShowMore() {
  var toggleButtons = document.querySelectorAll('.toggle-show-more');

  toggleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var readMore = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.read_more) ? window.PXUTheme.theme_settings.read_more : '';
      var readLess = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.read_less) ? window.PXUTheme.theme_settings.read_less : '';
      var current = (button.textContent || '').trim();

      if (current === (readMore || '').trim()) {
        button.textContent = readLess;
      } else {
        button.textContent = readMore;
      }

      var toggleContents = button.parentElement.querySelectorAll('.toggle-content');
      var toggleDesc = button.parentElement.querySelectorAll('.short-desc');

      toggleContents.forEach(function (content) {
        content.classList.toggle('d-none');
      });
      toggleDesc.forEach(function (content) {
        content.classList.toggle('extend');
      });
    });
  });
}

// Ensure DOM is ready so listeners attach to existing accordions
document.addEventListener('DOMContentLoaded', function () {
  toggleShowMore();
});

// $('.swatch-element').parent().parent()

// document.addEventListener('DOMContentLoaded', function() {
//   var swatches = document.querySelectorAll('.swatch-element');

//   swatches.forEach(function(swatch) {
//     swatch.addEventListener('click', function() {
//       var selectedColor = this.getAttribute('data-value');
//       var selectedColorSpan = swatch.parentNode.parentNode;;
//       selectedColorSpan.textContent = selectedColor;
//     });
//   });
// });

$('body').on('mousedown', '.swatch-element', function (e) {
  e.preventDefault();
});

$('body').on('change', '.swatch_options input[type="radio"]', function () {
  this.blur();
});

$('body').on('click', '.swatch-element', function () {
  const $swatch = $(this);
  const selectedColor = $swatch.attr('data-value');

  $swatch.parent().parent().find('.option-title-wrap .selected-option').text(selectedColor);

  const swatchValue = $swatch.data('value');
  if (swatchValue != null) {
    $swatch
      .siblings(`input[value="${String(swatchValue).replace(/"/g, '\\"')}"]`)
      .prop('checked', true)
      .trigger('change');
  }

  const $section = $swatch.closest('.js-product-section');
  const productGallery = $section.find('.product_gallery')[0];
  const isColorSwatch = $swatch.hasClass('color');
  const isAltGallery = productGallery && productGallery.dataset.productAlternative === 'true';
  const isColorGallery = productGallery && productGallery.dataset.productColorGallery === 'true';
  const colorKey = $swatch.attr('data-color-key') || (swatchValue != null ? toSlug(String(swatchValue)) : '');

  if (isColorSwatch && productGallery && (isColorGallery || isAltGallery)) {
    const galleryCells = $section.find('.js-product-gallery .gallery-cell.main-img');
    const $form = $swatch.closest('.product_form');
    const productData = $form.data('product');
    const swatchVariantId = ($swatch.attr('data-id') || '').trim();

    const syncGalleryForSwatch = () => {
      let variant = null;

      if (swatchVariantId && productData && window.getProductVariantById) {
        variant = window.getProductVariantById(productData, swatchVariantId);
      }

      if (!variant && window.getActiveProductVariantFromForm) {
        variant = window.getActiveProductVariantFromForm($form);
      }

      if (!variant && swatchVariantId && productData) {
        variant = window.getProductVariantById(productData, swatchVariantId);
      }

      if (variant && window.syncProductGalleryToVariant) {
        window.syncProductGalleryToVariant(
          $section,
          variant,
          productData ? productData.options : null,
          isColorGallery ? colorKey : null,
        );
        return;
      }

      if (isAltGallery) {
        const ownerId = ($swatch.attr('data-owner-product-id') || '').trim();

        if (ownerId && window.filterProductGalleryByOwnerId) {
          if (productGallery) {
            productGallery.dataset.selectedOwnerId = ownerId;
          }
          window.filterProductGalleryByOwnerId(galleryCells, ownerId);

          if (window.Flickity) {
            const flkty = window.Flickity.data(productGallery);
            if (flkty) flkty.resize();
          }

          if (window.selectFlickityGalleryForVariant) {
            const $visibleTarget = galleryCells.not('.gallery-cell--color-hidden').first();
            if ($visibleTarget.length) {
              window.selectFlickityGalleryForVariant($section, {
                featured_image: { id: $visibleTarget.attr('data-media-id') },
              });
            }
          }
        }
        return;
      }

      if (isColorGallery && colorKey && window.filterProductGalleryByColorKey) {
        window.filterProductGalleryByColorKey(galleryCells, colorKey);
      }

      if (window.selectFlickityGalleryForVariant) {
        const $visibleTarget = $section.find('.gallery-cell.main-img').not('.gallery-cell--color-hidden').first();
        if ($visibleTarget.length) {
          window.selectFlickityGalleryForVariant($section, {
            featured_image: { id: $visibleTarget.attr('data-media-id') },
          });
        }
      }
    };

    window.setTimeout(syncGalleryForSwatch, 0);
  }

  if ($swatch.hasClass('color') && window.updateComplementaryProducts) {
    const colorKeyForComplementary = $swatch.attr('data-color-key') || toSlug(String(swatchValue || ''));
    $('[data-complementary-products]').removeAttr('data-complementary-synced-key');
    window.updateComplementaryProducts(colorKeyForComplementary, selectedColor);
  } else {
    const $swatchGroup = $swatch.closest('.swatch');
    const $form = $swatch.closest('.product_form');
    const productData = $form.data('product');
    const optionIndex = parseInt($swatchGroup.attr('data-option-index'), 10);
    const optionName = productData && productData.options ? productData.options[optionIndex] : '';

    if (isColorOptionName(optionName) && window.updateComplementaryProducts) {
      const colorKeyForComplementary = $swatch.attr('data-color-key') || toSlug(String(swatchValue || ''));
      $('[data-complementary-products]').removeAttr('data-complementary-synced-key');
      window.updateComplementaryProducts(colorKeyForComplementary, selectedColor);
    }
  }
});


//   document.addEventListener('DOMContentLoaded', function () {
//   const filterGroups = document.querySelectorAll('.faceted-filter-group');
//   const threshold = 5; // Number of filters to show initially

//   filterGroups.forEach(filterGroup => {
//     const filters = filterGroup.querySelectorAll('.faceted-filter-group-display__list-item');
//     const showMoreBtn = document.createElement('div');

//     if (filters.length > threshold) {
//       for (let i = threshold; i < filters.length; i++) {
//         filters[i].style.display = 'none'; // Hide extra filters
//       }
//       showMoreBtn.textContent = 'See more';
//       showMoreBtn.classList.add('show-more-btn','text-underline','pointer','mb-20');
//       filterGroup.appendChild(showMoreBtn);

//       showMoreBtn.addEventListener('click', function () {
//         const isExpanded = showMoreBtn.textContent === 'Show less';
//         showMoreBtn.textContent = isExpanded ? 'See more' : 'Show less';

//         // Toggle visibility of extra filters
//         for (let i = threshold; i < filters.length; i++) {
//           filters[i].style.display = isExpanded ? 'none' : 'block';
//         }
//       });
//     }
//   });
// });



document.addEventListener('DOMContentLoaded', function () {
  const filterGroups = document.querySelectorAll('.faceted-filter-group');
  const threshold = 5; // Number of filters to show initially

  filterGroups.forEach(filterGroup => {
    const filters = filterGroup.querySelectorAll('.faceted-filter-group-display__list-item');
    const showMoreBtn = document.createElement('div');

    if (filters.length > threshold) {
      for (let i = threshold; i < filters.length; i++) {
        filters[i].style.display = 'none'; // Hide extra filters
      }
      showMoreBtn.textContent = window.PXUTheme.translation.show_more;
      showMoreBtn.classList.add('show-more-btn', 'text-underline', 'pointer', 'mb-20');
      filterGroup.appendChild(showMoreBtn);

      showMoreBtn.addEventListener('click', function () {
        const isExpanded = showMoreBtn.textContent === window.PXUTheme.translation.show_less;
        showMoreBtn.textContent = isExpanded ? window.PXUTheme.translation.show_more : window.PXUTheme.translation.show_less;

        // Toggle visibility of extra filters
        for (let i = threshold; i < filters.length; i++) {
          filters[i].style.display = isExpanded ? 'none' : 'block';
        }

        // Recalculate the open height of the filter group
        // setOpenHeight(filterGroup);
      });
    }
  });

  // Function to calculate and set the open height of the filter group
  const setOpenHeight = filterGroup => {
    const transition = window.animations.transition({
      el: filterGroup,
      stateAttribute: 'data-sidebar-block-state',
      stateChangeAttribute: 'data-sidebar-block-animation'
    });

    const block = filterGroup;

    // Temporarily show all the filters to calculate the height accurately
    const hiddenFilters = filterGroup.querySelectorAll('.faceted-filter-group-display__list-item[style="display: none;"]');
    hiddenFilters.forEach(filter => {
      filter.style.display = 'block';
    });

    const { height: openHeight } = filterGroup.getBoundingClientRect();

    // Hide the extra filters again
    hiddenFilters.forEach(filter => {
      filter.style.display = 'none';
    });

    block.style.setProperty('--open-height', `${openHeight}px`);
    transition.animateTo('closed');
  };
});

function createStickyATC() {
  // Step 1: Select the element to duplicate by its class name
  let originalElement = document.querySelector('.purchase-details__buttons .ajax-submit');
  let elementATC = document.querySelector('.sticky-atc');

  if (!originalElement || !elementATC) {
    return;
  }

  // Step 2: Create a clone of the selected element
  let clonedElement = originalElement.cloneNode(true); // true to clone all descendants
  clonedElement.classList.remove('ajax-submit');

  // Step 3: Insert the cloned element into the DOM
  elementATC.appendChild(clonedElement);

  // Step 4: Add click event listener to the cloned element
  clonedElement.addEventListener('click', function () {
    // Trigger a click event on the original button
    originalElement.click();
  });

  document.addEventListener('variantChange', function (event) {
    let { variant } = event.detail; // Assumes `variantChange` includes the variant info in event.detail

    const message = variant
      ? variant.available
        ? window.PXUTheme.translation.available_text
        : window.PXUTheme.translation.sold_out_text
      : window.PXUTheme.translation.unavailable_text;

    if (variant && variant.available) {
      clonedElement.classList.remove('disabled');
      clonedElement.removeAttribute('disabled');
      clonedElement.querySelector('span').textContent = window.PXUTheme.translation.add_to_cart;
    } else {
      clonedElement.classList.add('disabled');
      clonedElement.setAttribute('disabled', 'disabled');
      clonedElement.querySelector('span').textContent = message;
    }
  });
}

function hideElementIfOriginalVisible() {
  document.addEventListener("scroll", function () {
    if (window.innerWidth > 798) {
      return; // Exit if screen width is greater than 798px
    }
    let originalElement = document.querySelector('.purchase-details__buttons .ajax-submit');
    let elementATC = document.querySelector('.sticky-atc');

    if (!originalElement || !elementATC) {
      return; // Exit if either element is not found
    }

    var scrollPosition = window.scrollY;
    var windowHeight = window.innerHeight;
    var documentHeight = document.documentElement.scrollHeight;
    var scrollPercent = (scrollPosition / (documentHeight - windowHeight)) * 100;

    if (scrollPercent > 25) {
      elementATC.style.display = 'block'; // show elementATC
    } else {
      elementATC.style.display = 'none'; // hide elementATC
    }
  });
}

function loadProductCrossSell(product_id) {
  // this function for cart update
  const $productRecommendations = $('[data-product-crosssell]');
  const $productRecommendationsSection = $('.crosssell-wrap');
  const sectionID = $productRecommendations.data('section-id');
  const productID = product_id;
  const limit = $productRecommendations.data('limit');
  const recommendationsURL = $productRecommendations.data('recommendations-url');
  const sectionEnabled = $productRecommendationsSection.find($productRecommendations).data('enabled');
  const $recommendedProductSlider = $('.js-crosssell-products-slider');
  const selectedColor = $productRecommendations.data('selected-color');

  if (typeof product_id === 'undefined' || !product_id) {
    return;
  }

  if (!sectionID || !recommendationsURL) {
    return;
  }

  function loadDynamicProducts() {
    // Build request URL
    const requestUrl = `${recommendationsURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

    window.quickShop.init();

    // Make ajax call to request information for window.Shopify's recommended products
    $.ajax({
      type: 'GET',
      url: requestUrl,
      success(data) {
        if (!sectionEnabled) {
          return;
        }

        const $recommendedProductsElement = $(data).find('.product-crosssell').html();

        // Insert product list into the product recommendations container
        $productRecommendations.html($recommendedProductsElement);

        // Initialize product slider if it exists on page
        if ($recommendedProductSlider.length) {
          window.productPage.recommendedProductsSlider();
        } else {
          // Call enable gallery function for product galleries
          $('[data-product-crosssell] [data-product-gallery]').each((_, gallery) => {
            const $productGallery = $(gallery);
            window.productPage.enableGallery($productGallery);
          });
        }

        // Converting the currencies
        if (window.PXUTheme.currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }

        // // Run option selectors
        window.productPage.runOptionSelector($productRecommendationsSection);

        // Initialize shopify payment buttons
        if (window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        // Hide <noscript> elements
        window.hideNoScript();

        // // Initialize video players
        window.videoFeature.setupRecommendedVideoPlayer();


        // Initialize swatch toggler
        $('.swatch_options label').on('click', function () {
          window.quickShop.toggleSwatchImages($(this));
        });

        // Initialize the show secondary media on hover feature
        if (window.PXUTheme.theme_settings.collection_secondary_image) {
          window.imageFunctions.showSecondaryImage();
        }

        // change image by color for cross sell product
        const optionAvailable = $productRecommendations.find('[data-variant-color="' + selectedColor + '"] span');

        // Loop through the span elements
        optionAvailable.each(function () {
          const swatchImage = $(this).data('image');

          // Check if the image URL is valid
          if (swatchImage && swatchImage.indexOf('no-image') === -1) {
            // Find the image element inside the current product's thumbnail
            const $quickShopElement = $(this).closest('.thumbnail').find('.image__container img');

            if ($quickShopElement.length) {
              // Update the 'data-src' and 'data-srcset' attributes with the new image URL
              $quickShopElement.attr('data-src', swatchImage);
              $quickShopElement.attr('data-srcset', swatchImage);
            }
          }
        });
      },
    });
  }

  if (!sectionEnabled) { return; }

  // If meta collection, no need to run API request
  const metaCollection = $productRecommendations.hasClass('meta-related-recommended-collection');

  if (metaCollection) {
    // Takes care of moving content from Shopify section into block container

    // Initialize product slider if it exists on page
    if ($recommendedProductSlider.length) {
      window.productPage.recommendedProductsSlider();
    } else {
      // Call enable gallery function for product galleries
      $('.product-recommendations [data-product-gallery]').each(function () {
        const $productGallery = $(this);
        window.productPage.enableGallery($productGallery);
      });
    }

    // Run option selectors
    window.productPage.runOptionSelector($productRecommendationsSection);
  } else {
    loadDynamicProducts();
  }
}

// Function to convert a string to slug format
function toSlug(text) {
  if (text == null || text === '') return '';

  return String(text)
    .toLowerCase()          // Convert to lowercase
    .replace(/[^\w\s-]/g, '') // Remove all non-word chars
    .replace(/\s+/g, '-')    // Replace spaces with hyphens
    .replace(/--+/g, '-');   // Replace multiple hyphens with a single hyphen
}

function isColorOptionName(name) {
  const n = String(name == null ? '' : name).toLowerCase();
  return (
    n.includes('color') ||
    n.includes('colour') ||
    n.includes('farbe') ||
    n.includes('couleur') ||
    n.includes('colore') ||
    n.includes('farve') ||
    n.includes('maat') ||
    n.includes('kleur') ||
    n === 'cor' ||
    n === 'färg'
  );
}

window.toSlug = toSlug;
window.isColorOptionName = isColorOptionName;

createStickyATC();
hideElementIfOriginalVisible();

const titles = document.querySelectorAll(".collection-recommendations .feature-inner .title");

if (titles.length > 0) {
  titles.forEach(title => {
    let words = title.innerHTML.split(" ");
    if (words.length > 0) {
      words[0] = `<span class="bolder white">${words[0]}</span>`;
      title.innerHTML = words.join(" ");
    }
  });
}
